"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7138],{

/***/ 79554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ composeEventHandlers; }
/* harmony export */ });
function composeEventHandlers(e, n, {
  checkForDefaultPrevented: t = !0
} = {}) {
  return function (r) {
    if (null == e || e(r), !1 === t || !r.defaultPrevented) return null == n ? void 0 : n(r);
  };
}

/***/ }),

/***/ 56155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ createCollection; }
/* harmony export */ });
/* harmony import */ var _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92434);
/* harmony import */ var _radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30018);
/* harmony import */ var _radix_ui_react_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19686);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);




function createCollection(c) {
  const n = c + "CollectionProvider",
    [l, i] = (0,_radix_ui_react_context__WEBPACK_IMPORTED_MODULE_1__/* .createContextScope */ .b)(n),
    [f, a] = l(n, {
      collectionRef: {
        current: null
      },
      itemMap: new Map()
    }),
    u = e => {
      const {
          scope: r,
          children: t
        } = e,
        c = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null),
        n = react__WEBPACK_IMPORTED_MODULE_0__.useRef(new Map()).current; /*#__PURE__*/
      return react__WEBPACK_IMPORTED_MODULE_0__.createElement(f, {
        scope: r,
        itemMap: n,
        collectionRef: c
      }, t);
    },
    m = c + "CollectionSlot",
    s = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((t, c) => {
      const {
          scope: n,
          children: l
        } = t,
        i = a(m, n),
        f = (0,_radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_2__/* .useComposedRefs */ .e)(c, i.collectionRef); /*#__PURE__*/
      return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_3__/* .Slot */ .g7, {
        ref: f
      }, l);
    }),
    p = c + "CollectionItemSlot",
    d = "data-radix-collection-item",
    R = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((t, c) => {
      const {
          scope: n,
          children: l,
          ...i
        } = t,
        f = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null),
        u = (0,_radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_2__/* .useComposedRefs */ .e)(c, f),
        m = a(p, n);
      return react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => (m.itemMap.set(f, {
        ref: f,
        ...i
      }), () => {
        m.itemMap.delete(f);
      })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_3__/* .Slot */ .g7, {
        [d]: "",
        ref: u
      }, l);
    });
  return [{
    Provider: u,
    Slot: s,
    ItemSlot: R
  }, function (e) {
    const r = a(c + "CollectionConsumer", e);
    return react__WEBPACK_IMPORTED_MODULE_0__.useCallback(() => {
      const e = r.collectionRef.current;
      if (!e) return [];
      const t = Array.from(e.querySelectorAll(`[${d}]`));
      return Array.from(r.itemMap.values()).sort((e, r) => t.indexOf(e.ref.current) - t.indexOf(r.ref.current));
    }, [r.collectionRef, r.itemMap]);
  }, i];
}

/***/ }),

/***/ 30018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ composeRefs; },
/* harmony export */   "e": function() { return /* binding */ useComposedRefs; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);

function composeRefs(...o) {
  return e => o.forEach(o => function (o, e) {
    "function" == typeof o ? o(e) : null != o && (o.current = e);
  }(o, e));
}
function useComposedRefs(...e) {
  return react__WEBPACK_IMPORTED_MODULE_0__.useCallback(composeRefs(...e), e);
}

/***/ }),

/***/ 19686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ createContextScope; }
/* harmony export */ });
/* unused harmony export createContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);

function createContext(t, n) {
  const o = /*#__PURE__*/e.createContext(n);
  function r(t) {
    const {
        children: n,
        ...r
      } = t,
      c = e.useMemo(() => r, Object.values(r)); /*#__PURE__*/
    return e.createElement(o.Provider, {
      value: c
    }, n);
  }
  return r.displayName = t + "Provider", [r, function (r) {
    const c = e.useContext(o);
    if (c) return c;
    if (void 0 !== n) return n;
    throw new Error(`\`${r}\` must be used within \`${t}\``);
  }];
}
function createContextScope(n, o = []) {
  let r = [];
  const c = () => {
    const t = r.map(t => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(t));
    return function (o) {
      const r = (null == o ? void 0 : o[n]) || t;
      return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => ({
        [`__scope${n}`]: {
          ...o,
          [n]: r
        }
      }), [o, r]);
    };
  };
  return c.scopeName = n, [function (t, o) {
    const c = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(o),
      u = r.length;
    function s(t) {
      const {
          scope: o,
          children: r,
          ...s
        } = t,
        i = (null == o ? void 0 : o[n][u]) || c,
        a = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => s, Object.values(s)); /*#__PURE__*/
      return react__WEBPACK_IMPORTED_MODULE_0__.createElement(i.Provider, {
        value: a
      }, r);
    }
    return r = [...r, o], s.displayName = t + "Provider", [s, function (r, s) {
      const i = (null == s ? void 0 : s[n][u]) || c,
        a = react__WEBPACK_IMPORTED_MODULE_0__.useContext(i);
      if (a) return a;
      if (void 0 !== o) return o;
      throw new Error(`\`${r}\` must be used within \`${t}\``);
    }];
  }, t(c, ...o)];
}
function t(...t) {
  const n = t[0];
  if (1 === t.length) return n;
  const o = () => {
    const o = t.map(e => ({
      useScope: e(),
      scopeName: e.scopeName
    }));
    return function (t) {
      const r = o.reduce((e, {
        useScope: n,
        scopeName: o
      }) => ({
        ...e,
        ...n(t)[`__scope${o}`]
      }), {});
      return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => ({
        [`__scope${n.scopeName}`]: r
      }), [r]);
    };
  };
  return o.scopeName = n.scopeName, o;
}

/***/ }),

/***/ 57138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Eh": function() { return /* binding */ react_dropdown_menu_dist_index_module_Arrow; },
  "VY": function() { return /* binding */ dist_index_module_Content; },
  "ck": function() { return /* binding */ dist_index_module_Item; },
  "fC": function() { return /* binding */ react_dropdown_menu_dist_index_module_Root; },
  "xz": function() { return /* binding */ Trigger; }
});

// UNUSED EXPORTS: CheckboxItem, DropdownMenu, DropdownMenuArrow, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuItemIndicator, DropdownMenuLabel, DropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuSeparator, DropdownMenuTrigger, DropdownMenuTriggerItem, Group, ItemIndicator, Label, RadioGroup, RadioItem, Separator, TriggerItem, createDropdownMenuScope

// EXTERNAL MODULE: ./node_modules/@radix-ui/react-id/dist/index.module.js
var index_module = __webpack_require__(60158);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(82684);
;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-focus-guards/dist/index.module.js

let index_module_t = 0;
function FocusGuards(e) {
  return useFocusGuards(), e.children;
}
function useFocusGuards() {
  react.useEffect(() => {
    var e, n;
    const r = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", null !== (e = r[0]) && void 0 !== e ? e : index_module_o()), document.body.insertAdjacentElement("beforeend", null !== (n = r[1]) && void 0 !== n ? n : index_module_o()), index_module_t++, () => {
      1 === index_module_t && document.querySelectorAll("[data-radix-focus-guard]").forEach(e => e.remove()), index_module_t--;
    };
  }, []);
}
function index_module_o() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
const Root = (/* unused pure expression or super */ null && (FocusGuards));
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-use-callback-ref/dist/index.module.js
var dist_index_module = __webpack_require__(35849);
;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-use-direction/dist/index.module.js

function useDirection(t, n) {
  const [r, o] = react.useState("ltr"),
    [i, u] = react.useState(),
    c = react.useRef(0);
  return react.useEffect(() => {
    if (void 0 === n && null != t && t.parentElement) {
      const e = getComputedStyle(t.parentElement);
      u(e);
    }
  }, [t, n]), react.useEffect(() => (void 0 === n && function e() {
    c.current = requestAnimationFrame(() => {
      const t = null == i ? void 0 : i.direction;
      t && o(t), e();
    });
  }(), () => cancelAnimationFrame(c.current)), [i, n, o]), n || r;
}
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-use-controllable-state/dist/index.module.js
var react_use_controllable_state_dist_index_module = __webpack_require__(25320);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-primitive/dist/index.module.js
var react_primitive_dist_index_module = __webpack_require__(32587);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-context/dist/index.module.js
var react_context_dist_index_module = __webpack_require__(19686);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-compose-refs/dist/index.module.js
var react_compose_refs_dist_index_module = __webpack_require__(30018);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-collection/dist/index.module.js
var react_collection_dist_index_module = __webpack_require__(56155);
// EXTERNAL MODULE: ./node_modules/@radix-ui/primitive/dist/index.module.js
var primitive_dist_index_module = __webpack_require__(79554);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(65260);
;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-roving-focus/dist/index.module.js










const f = {
    bubbles: !1,
    cancelable: !0
  },
  [p, index_module_l, m] = (0,react_collection_dist_index_module/* createCollection */.B)("RovingFocusGroup"),
  [d, index_module_v] = (0,react_context_dist_index_module/* createContextScope */.b)("RovingFocusGroup", [m]);

const [g, F] = d("RovingFocusGroup");
const RovingFocusGroup = /*#__PURE__*/react.forwardRef((e, o) => /*#__PURE__*/react.createElement(p.Provider, {
  scope: e.__scopeRovingFocusGroup
}, /*#__PURE__*/react.createElement(p.Slot, {
  scope: e.__scopeRovingFocusGroup
}, /*#__PURE__*/react.createElement(index_module_w, (0,esm_extends/* default */.Z)({}, e, {
  ref: o
}))))); /*#__PURE__*/
const index_module_w = /*#__PURE__*/react.forwardRef((t, n) => {
  const {
      __scopeRovingFocusGroup: c,
      orientation: p,
      dir: m = "ltr",
      loop: d = !1,
      currentTabStopId: v,
      defaultCurrentTabStopId: F,
      onCurrentTabStopIdChange: w,
      onEntryFocus: b,
      ...x
    } = t,
    E = react.useRef(null),
    I = (0,react_compose_refs_dist_index_module/* useComposedRefs */.e)(n, E),
    [G = null, h] = (0,react_use_controllable_state_dist_index_module/* useControllableState */.T)({
      prop: v,
      defaultProp: F,
      onChange: w
    }),
    [T, A] = react.useState(!1),
    y = (0,dist_index_module/* useCallbackRef */.W)(b),
    D = index_module_l(c),
    S = react.useRef(!1);
  return react.useEffect(() => {
    const e = E.current;
    if (e) return e.addEventListener("rovingFocusGroup.onEntryFocus", y), () => e.removeEventListener("rovingFocusGroup.onEntryFocus", y);
  }, [y]), /*#__PURE__*/react.createElement(g, {
    scope: c,
    orientation: p,
    dir: m,
    loop: d,
    currentTabStopId: G,
    onItemFocus: react.useCallback(e => h(e), [h]),
    onItemShiftTab: react.useCallback(() => A(!0), [])
  }, /*#__PURE__*/react.createElement(react_primitive_dist_index_module/* Primitive.div */.W.div, (0,esm_extends/* default */.Z)({
    tabIndex: T ? -1 : 0,
    "data-orientation": p
  }, x, {
    ref: I,
    style: {
      outline: "none",
      ...t.style
    },
    onMouseDown: (0,primitive_dist_index_module/* composeEventHandlers */.M)(t.onMouseDown, () => {
      S.current = !0;
    }),
    onFocus: (0,primitive_dist_index_module/* composeEventHandlers */.M)(t.onFocus, e => {
      const o = !S.current;
      if (e.target === e.currentTarget && o && !T) {
        const o = new Event("rovingFocusGroup.onEntryFocus", f);
        if (e.currentTarget.dispatchEvent(o), !o.defaultPrevented) {
          const e = D().filter(e => e.focusable);
          R([e.find(e => e.active), e.find(e => e.id === G), ...e].filter(Boolean).map(e => e.ref.current));
        }
      }
      S.current = !1;
    }),
    onBlur: (0,primitive_dist_index_module/* composeEventHandlers */.M)(t.onBlur, () => A(!1))
  })));
});
const RovingFocusGroupItem = /*#__PURE__*/react.forwardRef((e, o) => {
  const {
      __scopeRovingFocusGroup: n,
      focusable: i = !0,
      active: c = !1,
      ...f
    } = e,
    m = (0,index_module/* useId */.M)(),
    d = F("RovingFocusGroupItem", n),
    v = d.currentTabStopId === m,
    g = index_module_l(n); /*#__PURE__*/
  return react.createElement(p.ItemSlot, {
    scope: n,
    id: m,
    focusable: i,
    active: c
  }, /*#__PURE__*/react.createElement(react_primitive_dist_index_module/* Primitive.span */.W.span, (0,esm_extends/* default */.Z)({
    tabIndex: v ? 0 : -1,
    "data-orientation": d.orientation
  }, f, {
    ref: o,
    onMouseDown: (0,primitive_dist_index_module/* composeEventHandlers */.M)(e.onMouseDown, e => {
      i ? d.onItemFocus(m) : e.preventDefault();
    }),
    onFocus: (0,primitive_dist_index_module/* composeEventHandlers */.M)(e.onFocus, () => d.onItemFocus(m)),
    onKeyDown: (0,primitive_dist_index_module/* composeEventHandlers */.M)(e.onKeyDown, e => {
      if ("Tab" === e.key && e.shiftKey) return void d.onItemShiftTab();
      if (e.target !== e.currentTarget) return;
      const o = function (e, o, r) {
        const t = function (e, o) {
          return "rtl" !== o ? e : "ArrowLeft" === e ? "ArrowRight" : "ArrowRight" === e ? "ArrowLeft" : e;
        }(e.key, r);
        return "vertical" === o && ["ArrowLeft", "ArrowRight"].includes(t) || "horizontal" === o && ["ArrowUp", "ArrowDown"].includes(t) ? void 0 : b[t];
      }(e, d.orientation, d.dir);
      if (void 0 !== o) {
        e.preventDefault();
        let n = g().filter(e => e.focusable).map(e => e.ref.current);
        if ("last" === o) n.reverse();else if ("prev" === o || "next" === o) {
          "prev" === o && n.reverse();
          const i = n.indexOf(e.currentTarget);
          n = d.loop ? (t = i + 1, (r = n).map((e, o) => r[(t + o) % r.length])) : n.slice(i + 1);
        }
        setTimeout(() => R(n));
      }
      var r, t;
    })
  })));
}); /*#__PURE__*/
const b = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function R(e) {
  const o = document.activeElement;
  for (const r of e) {
    if (r === o) return;
    if (r.focus(), document.activeElement !== o) return;
  }
}
const index_module_Root = RovingFocusGroup;
const Item = RovingFocusGroupItem;
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-use-layout-effect/dist/index.module.js
var react_use_layout_effect_dist_index_module = __webpack_require__(55483);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(85202);
;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-portal/dist/index.module.js





const Portal = /*#__PURE__*/react.forwardRef((a, i) => {
  var n, d;
  const {
      containerRef: s,
      style: u,
      ...c
    } = a,
    m = null !== (n = null == s ? void 0 : s.current) && void 0 !== n ? n : null === globalThis || void 0 === globalThis || null === (d = globalThis.document) || void 0 === d ? void 0 : d.body,
    [, f] = react.useState({});
  return (0,react_use_layout_effect_dist_index_module/* useLayoutEffect */.b)(() => {
    f({});
  }, []), m ? /*#__PURE__*/react_dom.createPortal( /*#__PURE__*/react.createElement(react_primitive_dist_index_module/* Primitive.div */.W.div, (0,esm_extends/* default */.Z)({
    "data-radix-portal": ""
  }, c, {
    ref: i,
    style: m === document.body ? {
      position: "absolute",
      top: 0,
      left: 0,
      zIndex: 2147483647,
      ...u
    } : void 0
  })), m) : null;
}); /*#__PURE__*/
const UnstablePortal = /*#__PURE__*/(/* unused pure expression or super */ null && (r.forwardRef((t, a) => {
  var i;
  const {
    container: n = null === globalThis || void 0 === globalThis || null === (i = globalThis.document) || void 0 === i ? void 0 : i.body,
    ...d
  } = t;
  return n ? /*#__PURE__*/e.createPortal( /*#__PURE__*/r.createElement(o.div, l({}, d, {
    ref: a
  })), n) : null;
}))); /*#__PURE__*/
const dist_index_module_Root = (/* unused pure expression or super */ null && (Portal));
;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-arrow/dist/index.module.js



const Arrow = /*#__PURE__*/react.forwardRef((o, i) => {
  const {
    children: n,
    width: s = 10,
    height: m = 5,
    ...p
  } = o; /*#__PURE__*/
  return react.createElement(react_primitive_dist_index_module/* Primitive.svg */.W.svg, (0,esm_extends/* default */.Z)({}, p, {
    ref: i,
    width: s,
    height: m,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none"
  }), o.asChild ? n : /*#__PURE__*/react.createElement("polygon", {
    points: "0,0 30,0 15,10"
  }));
}); /*#__PURE__*/
const react_arrow_dist_index_module_Root = Arrow;
;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-use-size/dist/index.module.js

function useSize(r) {
  const [i, t] = react.useState(void 0);
  return react.useEffect(() => {
    if (r) {
      const e = new ResizeObserver(e => {
        if (!Array.isArray(e)) return;
        if (!e.length) return;
        const i = e[0];
        let o, n;
        if ("borderBoxSize" in i) {
          const e = i.borderBoxSize,
            r = Array.isArray(e) ? e[0] : e;
          o = r.inlineSize, n = r.blockSize;
        } else {
          const e = r.getBoundingClientRect();
          o = e.width, n = e.height;
        }
        t({
          width: o,
          height: n
        });
      });
      return e.observe(r, {
        box: "border-box"
      }), () => e.unobserve(r);
    }
    t(void 0);
  }, [r]), i;
}
;// CONCATENATED MODULE: ./node_modules/@radix-ui/rect/dist/index.module.js
function observeElementRect(n, o) {
  const i = index_module_e.get(n);
  return void 0 === i ? (index_module_e.set(n, {
    rect: {},
    callbacks: [o]
  }), 1 === index_module_e.size && (dist_index_module_t = requestAnimationFrame(index_module_c))) : (i.callbacks.push(o), o(n.getBoundingClientRect())), () => {
    const c = index_module_e.get(n);
    if (void 0 === c) return;
    const i = c.callbacks.indexOf(o);
    i > -1 && c.callbacks.splice(i, 1), 0 === c.callbacks.length && (index_module_e.delete(n), 0 === index_module_e.size && cancelAnimationFrame(dist_index_module_t));
  };
}
let dist_index_module_t;
const index_module_e = new Map();
function index_module_c() {
  const n = [];
  index_module_e.forEach((t, e) => {
    const c = e.getBoundingClientRect();
    var o, i;
    o = t.rect, i = c, (o.width !== i.width || o.height !== i.height || o.top !== i.top || o.right !== i.right || o.bottom !== i.bottom || o.left !== i.left) && (t.rect = c, n.push(t));
  }), n.forEach(t => {
    t.callbacks.forEach(e => e(t.rect));
  }), dist_index_module_t = requestAnimationFrame(index_module_c);
}
;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-use-rect/dist/index.module.js


function useRect(e) {
  const [o, c] = react.useState();
  return react.useEffect(() => {
    if (e) {
      const r = observeElementRect(e, c);
      return () => {
        c(void 0), r();
      };
    }
  }, [e]), o;
}
;// CONCATENATED MODULE: ./node_modules/@radix-ui/popper/dist/index.module.js
const SIDE_OPTIONS = (/* unused pure expression or super */ null && (["top", "right", "bottom", "left"]));
const ALIGN_OPTIONS = (/* unused pure expression or super */ null && (["start", "center", "end"]));
function getPlacementData({
  anchorRect: p,
  popperSize: c,
  arrowSize: f,
  arrowOffset: l = 0,
  side: d,
  sideOffset: h = 0,
  align: x,
  alignOffset: g = 0,
  shouldAvoidCollisions: u = !0,
  collisionBoundariesRect: w,
  collisionTolerance: m = 0
}) {
  if (!p || !c || !w) return {
    popperStyles: dist_index_module_o,
    arrowStyles: n
  };
  const y = function (e, r, o = 0, n = 0, i) {
      const p = i ? i.height : 0,
        a = popper_dist_index_module_t(r, e, "x"),
        s = popper_dist_index_module_t(r, e, "y"),
        c = s.before - o - p,
        f = s.after + o + p,
        l = a.before - o - p,
        d = a.after + o + p;
      return {
        top: {
          start: {
            x: a.start + n,
            y: c
          },
          center: {
            x: a.center,
            y: c
          },
          end: {
            x: a.end - n,
            y: c
          }
        },
        right: {
          start: {
            x: d,
            y: s.start + n
          },
          center: {
            x: d,
            y: s.center
          },
          end: {
            x: d,
            y: s.end - n
          }
        },
        bottom: {
          start: {
            x: a.start + n,
            y: f
          },
          center: {
            x: a.center,
            y: f
          },
          end: {
            x: a.end - n,
            y: f
          }
        },
        left: {
          start: {
            x: l,
            y: s.start + n
          },
          center: {
            x: l,
            y: s.center
          },
          end: {
            x: l,
            y: s.end - n
          }
        }
      };
    }(c, p, h, g, f),
    b = y[d][x];
  if (!1 === u) {
    const t = dist_index_module_e(b);
    let o = n;
    f && (o = index_module_i({
      popperSize: c,
      arrowSize: f,
      arrowOffset: l,
      side: d,
      align: x
    }));
    return {
      popperStyles: {
        ...t,
        "--radix-popper-transform-origin": index_module_r(c, d, x, l, f)
      },
      arrowStyles: o,
      placedSide: d,
      placedAlign: x
    };
  }
  const S = DOMRect.fromRect({
      ...c,
      ...b
    }),
    $ = (O = w, z = m, DOMRect.fromRect({
      width: O.width - 2 * z,
      height: O.height - 2 * z,
      x: O.left + z,
      y: O.top + z
    }));
  var O, z;
  const R = index_module_s(S, $),
    M = y[index_module_a(d)][x],
    D = function (t, e, r) {
      const o = index_module_a(t);
      return e[t] && !r[o] ? o : t;
    }(d, R, index_module_s(DOMRect.fromRect({
      ...c,
      ...M
    }), $)),
    A = function (t, e, r, o, n) {
      const i = "top" === r || "bottom" === r,
        p = i ? "left" : "top",
        a = i ? "right" : "bottom",
        s = i ? "width" : "height",
        c = e[s] > t[s];
      if (("start" === o || "center" === o) && (n[p] && c || n[a] && !c)) return "end";
      if (("end" === o || "center" === o) && (n[a] && c || n[p] && !c)) return "start";
      return o;
    }(c, p, d, x, R),
    I = dist_index_module_e(y[D][A]);
  let C = n;
  f && (C = index_module_i({
    popperSize: c,
    arrowSize: f,
    arrowOffset: l,
    side: D,
    align: A
  }));
  return {
    popperStyles: {
      ...I,
      "--radix-popper-transform-origin": index_module_r(c, D, A, l, f)
    },
    arrowStyles: C,
    placedSide: D,
    placedAlign: A
  };
}
function popper_dist_index_module_t(t, e, r) {
  const o = t["x" === r ? "left" : "top"],
    n = "x" === r ? "width" : "height",
    i = t[n],
    p = e[n];
  return {
    before: o - p,
    start: o,
    center: o + (i - p) / 2,
    end: o + i - p,
    after: o + i
  };
}
function dist_index_module_e(t) {
  return {
    position: "absolute",
    top: 0,
    left: 0,
    minWidth: "max-content",
    willChange: "transform",
    transform: `translate3d(${Math.round(t.x + window.scrollX)}px, ${Math.round(t.y + window.scrollY)}px, 0)`
  };
}
function index_module_r(t, e, r, o, n) {
  const i = "top" === e || "bottom" === e,
    p = n ? n.width : 0,
    a = n ? n.height : 0,
    s = p / 2 + o;
  let c = "",
    f = "";
  return i ? (c = {
    start: `${s}px`,
    center: "center",
    end: t.width - s + "px"
  }[r], f = "top" === e ? `${t.height + a}px` : -a + "px") : (c = "left" === e ? `${t.width + a}px` : -a + "px", f = {
    start: `${s}px`,
    center: "center",
    end: t.height - s + "px"
  }[r]), `${c} ${f}`;
}
const dist_index_module_o = {
    position: "fixed",
    top: 0,
    left: 0,
    opacity: 0,
    transform: "translate3d(0, -200%, 0)"
  },
  n = {
    position: "absolute",
    opacity: 0
  };
function index_module_i({
  popperSize: t,
  arrowSize: e,
  arrowOffset: r,
  side: o,
  align: n
}) {
  const i = (t.width - e.width) / 2,
    a = (t.height - e.width) / 2,
    s = {
      top: 0,
      right: 90,
      bottom: 180,
      left: -90
    }[o],
    c = Math.max(e.width, e.height),
    f = {
      width: `${c}px`,
      height: `${c}px`,
      transform: `rotate(${s}deg)`,
      willChange: "transform",
      position: "absolute",
      [o]: "100%",
      direction: index_module_p(o, n)
    };
  return "top" !== o && "bottom" !== o || ("start" === n && (f.left = `${r}px`), "center" === n && (f.left = `${i}px`), "end" === n && (f.right = `${r}px`)), "left" !== o && "right" !== o || ("start" === n && (f.top = `${r}px`), "center" === n && (f.top = `${a}px`), "end" === n && (f.bottom = `${r}px`)), f;
}
function index_module_p(t, e) {
  return ("top" !== t && "right" !== t || "end" !== e) && ("bottom" !== t && "left" !== t || "end" === e) ? "ltr" : "rtl";
}
function index_module_a(t) {
  return {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
  }[t];
}
function index_module_s(t, e) {
  return {
    top: t.top < e.top,
    right: t.right > e.right,
    bottom: t.bottom > e.bottom,
    left: t.left < e.left
  };
}
;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-popper/dist/index.module.js









const [dist_index_module_c, dist_index_module_l] = (0,react_context_dist_index_module/* createContextScope */.b)("Popper");

const [index_module_f, index_module_d] = dist_index_module_c("Popper");
const Popper = e => {
  const {
      __scopePopper: o,
      children: r
    } = e,
    [t, n] = react.useState(null); /*#__PURE__*/
  return react.createElement(index_module_f, {
    scope: o,
    anchor: t,
    onAnchorChange: n
  }, r);
}; /*#__PURE__*/
const PopperAnchor = /*#__PURE__*/react.forwardRef((e, r) => {
  const {
      __scopePopper: t,
      virtualRef: n,
      ...p
    } = e,
    c = index_module_d("PopperAnchor", t),
    l = react.useRef(null),
    f = (0,react_compose_refs_dist_index_module/* useComposedRefs */.e)(r, l);
  return react.useEffect(() => {
    c.onAnchorChange((null == n ? void 0 : n.current) || l.current);
  }), n ? null : /*#__PURE__*/react.createElement(react_primitive_dist_index_module/* Primitive.div */.W.div, (0,esm_extends/* default */.Z)({}, p, {
    ref: f
  }));
}); /*#__PURE__*/
const [index_module_u, index_module_m] = dist_index_module_c("PopperContent");
const PopperContent = /*#__PURE__*/react.forwardRef((e, n) => {
  const {
      __scopePopper: c,
      side: l = "bottom",
      sideOffset: f,
      align: m = "center",
      alignOffset: w,
      collisionTolerance: h,
      avoidCollisions: x = !0,
      ...v
    } = e,
    P = index_module_d("PopperContent", c),
    [A, g] = react.useState(),
    E = useRect(P.anchor),
    [y, C] = react.useState(null),
    S = useSize(y),
    [R, O] = react.useState(null),
    _ = useSize(R),
    b = (0,react_compose_refs_dist_index_module/* useComposedRefs */.e)(n, e => C(e)),
    z = function () {
      const [e, o] = react.useState(void 0);
      return react.useEffect(() => {
        let e;
        function r() {
          o({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
        function t() {
          window.clearTimeout(e), e = window.setTimeout(r, 100);
        }
        return r(), window.addEventListener("resize", t), () => window.removeEventListener("resize", t);
      }, []), e;
    }(),
    T = z ? DOMRect.fromRect({
      ...z,
      x: 0,
      y: 0
    }) : void 0,
    {
      popperStyles: k,
      arrowStyles: L,
      placedSide: B,
      placedAlign: D
    } = getPlacementData({
      anchorRect: E,
      popperSize: S,
      arrowSize: _,
      arrowOffset: A,
      side: l,
      sideOffset: f,
      align: m,
      alignOffset: w,
      shouldAvoidCollisions: x,
      collisionBoundariesRect: T,
      collisionTolerance: h
    }),
    H = void 0 !== B; /*#__PURE__*/
  return react.createElement("div", {
    style: k,
    "data-radix-popper-content-wrapper": ""
  }, /*#__PURE__*/react.createElement(index_module_u, {
    scope: c,
    arrowStyles: L,
    onArrowChange: O,
    onArrowOffsetChange: g
  }, /*#__PURE__*/react.createElement(react_primitive_dist_index_module/* Primitive.div */.W.div, (0,esm_extends/* default */.Z)({
    "data-side": B,
    "data-align": D
  }, v, {
    style: {
      ...v.style,
      animation: H ? void 0 : "none"
    },
    ref: b
  }))));
}); /*#__PURE__*/
const PopperArrow = /*#__PURE__*/react.forwardRef(function (o, r) {
  const {
      __scopePopper: t,
      offset: n,
      ...i
    } = o,
    p = index_module_m("PopperArrow", t),
    {
      onArrowOffsetChange: c
    } = p;
  return react.useEffect(() => c(n), [c, n]), /*#__PURE__*/react.createElement("span", {
    style: {
      ...p.arrowStyles,
      pointerEvents: "none"
    }
  }, /*#__PURE__*/react.createElement("span", {
    ref: p.onArrowChange,
    style: {
      display: "inline-block",
      verticalAlign: "top",
      pointerEvents: "auto"
    }
  }, /*#__PURE__*/react.createElement(react_arrow_dist_index_module_Root, (0,esm_extends/* default */.Z)({}, i, {
    ref: r,
    style: {
      ...i.style,
      display: "block"
    }
  }))));
}); /*#__PURE__*/
const react_popper_dist_index_module_Root = Popper;
const Anchor = PopperAnchor;
const Content = PopperContent;
const index_module_Arrow = PopperArrow;
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-presence/dist/index.module.js
var react_presence_dist_index_module = __webpack_require__(17501);
;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-focus-scope/dist/index.module.js





const react_focus_scope_dist_index_module_c = {
  bubbles: !1,
  cancelable: !0
};
const FocusScope = /*#__PURE__*/react.forwardRef((i, f) => {
  const {
      loop: l = !1,
      trapped: m = !1,
      onMountAutoFocus: p,
      onUnmountAutoFocus: v,
      ...E
    } = i,
    [F, S] = react.useState(null),
    b = (0,dist_index_module/* useCallbackRef */.W)(p),
    T = (0,dist_index_module/* useCallbackRef */.W)(v),
    y = react.useRef(null),
    L = (0,react_compose_refs_dist_index_module/* useComposedRefs */.e)(f, e => S(e)),
    h = react.useRef({
      paused: !1,
      pause() {
        this.paused = !0;
      },
      resume() {
        this.paused = !1;
      }
    }).current;
  react.useEffect(() => {
    if (m) {
      function e(e) {
        if (h.paused || !F) return;
        const t = e.target;
        F.contains(t) ? y.current = t : dist_index_module_a(y.current, {
          select: !0
        });
      }
      function t(e) {
        !h.paused && F && (F.contains(e.relatedTarget) || dist_index_module_a(y.current, {
          select: !0
        }));
      }
      return document.addEventListener("focusin", e), document.addEventListener("focusout", t), () => {
        document.removeEventListener("focusin", e), document.removeEventListener("focusout", t);
      };
    }
  }, [m, F, h.paused]), react.useEffect(() => {
    if (F) {
      dist_index_module_d.add(h);
      const t = document.activeElement;
      if (!F.contains(t)) {
        const n = new Event("focusScope.autoFocusOnMount", react_focus_scope_dist_index_module_c);
        F.addEventListener("focusScope.autoFocusOnMount", b), F.dispatchEvent(n), n.defaultPrevented || (!function (e, {
          select: t = !1
        } = {}) {
          const n = document.activeElement;
          for (const o of e) if (dist_index_module_a(o, {
            select: t
          }), document.activeElement !== n) return;
        }((e = dist_index_module_r(F), e.filter(e => "A" !== e.tagName)), {
          select: !0
        }), document.activeElement === t && dist_index_module_a(F));
      }
      return () => {
        F.removeEventListener("focusScope.autoFocusOnMount", b), setTimeout(() => {
          const e = new Event("focusScope.autoFocusOnUnmount", react_focus_scope_dist_index_module_c);
          F.addEventListener("focusScope.autoFocusOnUnmount", T), F.dispatchEvent(e), e.defaultPrevented || dist_index_module_a(null != t ? t : document.body, {
            select: !0
          }), F.removeEventListener("focusScope.autoFocusOnUnmount", T), dist_index_module_d.remove(h);
        }, 0);
      };
    }
    var e;
  }, [F, b, T, h]);
  const N = react.useCallback(e => {
    if (!l && !m) return;
    if (h.paused) return;
    const t = "Tab" === e.key && !e.altKey && !e.ctrlKey && !e.metaKey,
      n = document.activeElement;
    if (t && n) {
      const t = e.currentTarget,
        [o, u] = function (e) {
          const t = dist_index_module_r(e),
            n = dist_index_module_s(t, e),
            o = dist_index_module_s(t.reverse(), e);
          return [n, o];
        }(t);
      o && u ? e.shiftKey || n !== u ? e.shiftKey && n === o && (e.preventDefault(), l && dist_index_module_a(u, {
        select: !0
      })) : (e.preventDefault(), l && dist_index_module_a(o, {
        select: !0
      })) : n === t && e.preventDefault();
    }
  }, [l, m, h.paused]); /*#__PURE__*/
  return react.createElement(react_primitive_dist_index_module/* Primitive.div */.W.div, (0,esm_extends/* default */.Z)({
    tabIndex: -1
  }, E, {
    ref: L,
    onKeyDown: N
  }));
}); /*#__PURE__*/
function dist_index_module_r(e) {
  const t = [],
    n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
      acceptNode: e => {
        const t = "INPUT" === e.tagName && "hidden" === e.type;
        return e.disabled || e.hidden || t ? NodeFilter.FILTER_SKIP : e.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
  for (; n.nextNode();) t.push(n.currentNode);
  return t;
}
function dist_index_module_s(e, t) {
  for (const n of e) if (!dist_index_module_i(n, {
    upTo: t
  })) return n;
}
function dist_index_module_i(e, {
  upTo: t
}) {
  if ("hidden" === getComputedStyle(e).visibility) return !0;
  for (; e;) {
    if (void 0 !== t && e === t) return !1;
    if ("none" === getComputedStyle(e).display) return !0;
    e = e.parentElement;
  }
  return !1;
}
function dist_index_module_a(e, {
  select: t = !1
} = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && function (e) {
      return e instanceof HTMLInputElement && "select" in e;
    }(e) && t && e.select();
  }
}
const dist_index_module_d = function () {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (null == n || n.pause()), e = dist_index_module_f(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = dist_index_module_f(e, t), null === (n = e[0]) || void 0 === n || n.resume();
    }
  };
}();
function dist_index_module_f(e, t) {
  const n = [...e],
    o = n.indexOf(t);
  return -1 !== o && n.splice(o, 1), n;
}
const react_focus_scope_dist_index_module_Root = (/* unused pure expression or super */ null && (FocusScope));
;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-use-escape-keydown/dist/index.module.js


function useEscapeKeydown(n) {
  const o = (0,dist_index_module/* useCallbackRef */.W)(n);
  react.useEffect(() => {
    const e = e => {
      "Escape" === e.key && o(e);
    };
    return document.addEventListener("keydown", e), () => document.removeEventListener("keydown", e);
  }, [o]);
}
;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-use-body-pointer-events/dist/index.module.js


let index_module_n,
  react_use_body_pointer_events_dist_index_module_o = 0;
function useBodyPointerEvents({
  disabled: r
}) {
  const i = react.useRef(!1);
  (0,react_use_layout_effect_dist_index_module/* useLayoutEffect */.b)(() => {
    if (r) {
      function e() {
        react_use_body_pointer_events_dist_index_module_o--, 0 === react_use_body_pointer_events_dist_index_module_o && (document.body.style.pointerEvents = index_module_n);
      }
      function t(e) {
        i.current = "mouse" !== e.pointerType;
      }
      return 0 === react_use_body_pointer_events_dist_index_module_o && (index_module_n = document.body.style.pointerEvents), document.body.style.pointerEvents = "none", react_use_body_pointer_events_dist_index_module_o++, document.addEventListener("pointerup", t), () => {
        i.current ? document.addEventListener("click", e, {
          once: !0
        }) : e(), document.removeEventListener("pointerup", t);
      };
    }
  }, [r]);
}
;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-dismissable-layer/dist/index.module.js








const dist_index_module_u = /*#__PURE__*/react.createContext({
  layers: new Set(),
  layersWithOutsidePointerEventsDisabled: new Set(),
  branches: new Set()
});
const DismissableLayer = /*#__PURE__*/react.forwardRef((l, m) => {
  const {
      disableOutsidePointerEvents: f = !1,
      onEscapeKeyDown: p,
      onPointerDownOutside: v,
      onFocusOutside: b,
      onInteractOutside: E,
      onDismiss: y,
      ...w
    } = l,
    h = react.useContext(dist_index_module_u),
    [D, x] = react.useState(null),
    [, C] = react.useState({}),
    L = (0,react_compose_refs_dist_index_module/* useComposedRefs */.e)(m, e => x(e)),
    P = Array.from(h.layers),
    [O] = [...h.layersWithOutsidePointerEventsDisabled].slice(-1),
    g = P.indexOf(O),
    B = D ? P.indexOf(D) : -1,
    R = h.layersWithOutsidePointerEventsDisabled.size > 0,
    F = B >= g,
    S = function (e) {
      const n = (0,dist_index_module/* useCallbackRef */.W)(e),
        r = react.useRef(!1);
      return react.useEffect(() => {
        const e = e => {
            if (e.target && !r.current) {
              react_dismissable_layer_dist_index_module_d("dismissableLayer.pointerDownOutside", n, {
                originalEvent: e
              });
            }
            r.current = !1;
          },
          t = window.setTimeout(() => {
            document.addEventListener("pointerdown", e);
          }, 0);
        return () => {
          window.clearTimeout(t), document.removeEventListener("pointerdown", e);
        };
      }, [n]), {
        onPointerDownCapture: () => r.current = !0
      };
    }(e => {
      const t = e.target,
        n = [...h.branches].some(e => e.contains(t));
      F && !n && (null == v || v(e), null == E || E(e), e.defaultPrevented || null == y || y());
    }),
    W = function (e) {
      const n = (0,dist_index_module/* useCallbackRef */.W)(e),
        r = react.useRef(!1);
      return react.useEffect(() => {
        const e = e => {
          if (e.target && !r.current) {
            react_dismissable_layer_dist_index_module_d("dismissableLayer.focusOutside", n, {
              originalEvent: e
            });
          }
        };
        return document.addEventListener("focusin", e), () => document.removeEventListener("focusin", e);
      }, [n]), {
        onFocusCapture: () => r.current = !0,
        onBlurCapture: () => r.current = !1
      };
    }(e => {
      const t = e.target;
      [...h.branches].some(e => e.contains(t)) || (null == b || b(e), null == E || E(e), e.defaultPrevented || null == y || y());
    });
  return useEscapeKeydown(e => {
    B === h.layers.size - 1 && (null == p || p(e), e.defaultPrevented || null == y || y());
  }), useBodyPointerEvents({
    disabled: f
  }), react.useEffect(() => {
    D && (f && h.layersWithOutsidePointerEventsDisabled.add(D), h.layers.add(D), react_dismissable_layer_dist_index_module_c());
  }, [D, f, h]), react.useEffect(() => () => {
    D && (h.layers.delete(D), h.layersWithOutsidePointerEventsDisabled.delete(D), react_dismissable_layer_dist_index_module_c());
  }, [D, h]), react.useEffect(() => {
    const e = () => C({});
    return document.addEventListener("dismissableLayer.update", e), () => document.removeEventListener("dismissableLayer.update", e);
  }, []), /*#__PURE__*/react.createElement(react_primitive_dist_index_module/* Primitive.div */.W.div, (0,esm_extends/* default */.Z)({}, w, {
    ref: L,
    style: {
      pointerEvents: R ? F ? "auto" : "none" : void 0,
      ...l.style
    },
    onFocusCapture: (0,primitive_dist_index_module/* composeEventHandlers */.M)(l.onFocusCapture, W.onFocusCapture),
    onBlurCapture: (0,primitive_dist_index_module/* composeEventHandlers */.M)(l.onBlurCapture, W.onBlurCapture),
    onPointerDownCapture: (0,primitive_dist_index_module/* composeEventHandlers */.M)(l.onPointerDownCapture, S.onPointerDownCapture)
  }));
}); /*#__PURE__*/
const DismissableLayerBranch = /*#__PURE__*/(/* unused pure expression or super */ null && (i.forwardRef((e, t) => {
  const n = i.useContext(dist_index_module_u),
    o = i.useRef(null),
    c = r(t, o);
  return i.useEffect(() => {
    const e = o.current;
    if (e) return n.branches.add(e), () => {
      n.branches.delete(e);
    };
  }, [n.branches]), /*#__PURE__*/i.createElement(s.div, a({}, e, {
    ref: c
  }));
}))); /*#__PURE__*/
function react_dismissable_layer_dist_index_module_c() {
  const e = new Event("dismissableLayer.update");
  document.dispatchEvent(e);
}
function react_dismissable_layer_dist_index_module_d(e, t, n) {
  const r = n.originalEvent.target,
    s = new CustomEvent(e, {
      bubbles: !1,
      cancelable: !0,
      detail: n
    });
  return t && r.addEventListener(e, t, {
    once: !0
  }), !r.dispatchEvent(s);
}
const react_dismissable_layer_dist_index_module_Root = (/* unused pure expression or super */ null && (DismissableLayer));
const Branch = (/* unused pure expression or super */ null && (DismissableLayerBranch));
;// CONCATENATED MODULE: ./node_modules/aria-hidden/dist/es2015/index.js
var getDefaultParent = function (originalTarget) {
  if (typeof document === 'undefined') {
    return null;
  }
  var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
  return sampleTarget.ownerDocument.body;
};
var counterMap = new WeakMap();
var uncontrolledNodes = new WeakMap();
var markerMap = {};
var lockCount = 0;
var unwrapHost = function (node) {
  return node && (node.host || unwrapHost(node.parentNode));
};
var correctTargets = function (parent, targets) {
  return targets.map(function (target) {
    if (parent.contains(target)) {
      return target;
    }
    var correctedTarget = unwrapHost(target);
    if (correctedTarget && parent.contains(correctedTarget)) {
      return correctedTarget;
    }
    console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
    return null;
  }).filter(function (x) {
    return Boolean(x);
  });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */
var applyAttributeToOthers = function (originalTarget, parentNode, markerName, controlAttribute) {
  var targets = correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
  if (!markerMap[markerName]) {
    markerMap[markerName] = new WeakMap();
  }
  var markerCounter = markerMap[markerName];
  var hiddenNodes = [];
  var elementsToKeep = new Set();
  var elementsToStop = new Set(targets);
  var keep = function (el) {
    if (!el || elementsToKeep.has(el)) {
      return;
    }
    elementsToKeep.add(el);
    keep(el.parentNode);
  };
  targets.forEach(keep);
  var deep = function (parent) {
    if (!parent || elementsToStop.has(parent)) {
      return;
    }
    Array.prototype.forEach.call(parent.children, function (node) {
      if (elementsToKeep.has(node)) {
        deep(node);
      } else {
        var attr = node.getAttribute(controlAttribute);
        var alreadyHidden = attr !== null && attr !== 'false';
        var counterValue = (counterMap.get(node) || 0) + 1;
        var markerValue = (markerCounter.get(node) || 0) + 1;
        counterMap.set(node, counterValue);
        markerCounter.set(node, markerValue);
        hiddenNodes.push(node);
        if (counterValue === 1 && alreadyHidden) {
          uncontrolledNodes.set(node, true);
        }
        if (markerValue === 1) {
          node.setAttribute(markerName, 'true');
        }
        if (!alreadyHidden) {
          node.setAttribute(controlAttribute, 'true');
        }
      }
    });
  };
  deep(parentNode);
  elementsToKeep.clear();
  lockCount++;
  return function () {
    hiddenNodes.forEach(function (node) {
      var counterValue = counterMap.get(node) - 1;
      var markerValue = markerCounter.get(node) - 1;
      counterMap.set(node, counterValue);
      markerCounter.set(node, markerValue);
      if (!counterValue) {
        if (!uncontrolledNodes.has(node)) {
          node.removeAttribute(controlAttribute);
        }
        uncontrolledNodes.delete(node);
      }
      if (!markerValue) {
        node.removeAttribute(markerName);
      }
    });
    lockCount--;
    if (!lockCount) {
      // clear
      counterMap = new WeakMap();
      counterMap = new WeakMap();
      uncontrolledNodes = new WeakMap();
      markerMap = {};
    }
  };
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @return {Undo} undo command
 */
var hideOthers = function (originalTarget, parentNode, markerName) {
  if (markerName === void 0) {
    markerName = 'data-aria-hidden';
  }
  var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
  var activeParentNode = parentNode || getDefaultParent(originalTarget);
  if (!activeParentNode) {
    return function () {
      return null;
    };
  }
  // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
  targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live]')));
  return applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
};
/**
 * Marks everything except given node(or nodes) as inert
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @return {Undo} undo command
 */
var inertOthers = function (originalTarget, parentNode, markerName) {
  if (markerName === void 0) {
    markerName = 'data-inert-ed';
  }
  var activeParentNode = parentNode || getDefaultParent(originalTarget);
  if (!activeParentNode) {
    return function () {
      return null;
    };
  }
  return applyAttributeToOthers(originalTarget, activeParentNode, markerName, 'inert');
};
/**
 * @returns if current browser supports inert
 */
var supportsInert = function () {
  return typeof HTMLElement !== 'undefined' && HTMLElement.prototype.hasOwnProperty('inert');
};
/**
 * Automatic function to "suppress" DOM elements - _hide_ or _inert_ in the best possible way
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @return {Undo} undo command
 */
var suppressOthers = function (originalTarget, parentNode, markerName) {
  if (markerName === void 0) {
    markerName = 'data-suppressed';
  }
  return (supportsInert() ? inertOthers : hideOthers)(originalTarget, parentNode, markerName);
};
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(52621);
;// CONCATENATED MODULE: ./node_modules/react-remove-scroll-bar/dist/es2015/constants.js
var zeroRightClassName = 'right-scroll-bar-position';
var fullWidthClassName = 'width-before-scroll-bar';
var noScrollbarsClassName = 'with-scroll-bars-hidden';
/**
 * Name of a CSS variable containing the amount of "hidden" scrollbar
 * ! might be undefined ! use will fallback!
 */
var removedBarSizeVariable = '--removed-body-scroll-bar-size';
;// CONCATENATED MODULE: ./node_modules/use-callback-ref/dist/es2015/assignRef.js
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */
function assignRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
  return ref;
}
;// CONCATENATED MODULE: ./node_modules/use-callback-ref/dist/es2015/useRef.js

/**
 * creates a MutableRef with ref change callback
 * @param initialValue - initial ref value
 * @param {Function} callback - a callback to run when value changes
 *
 * @example
 * const ref = useCallbackRef(0, (newValue, oldValue) => console.log(oldValue, '->', newValue);
 * ref.current = 1;
 * // prints 0 -> 1
 *
 * @see https://reactjs.org/docs/hooks-reference.html#useref
 * @see https://github.com/theKashey/use-callback-ref#usecallbackref---to-replace-reactuseref
 * @returns {MutableRefObject}
 */
function useCallbackRef(initialValue, callback) {
  var ref = (0,react.useState)(function () {
    return {
      // value
      value: initialValue,
      // last callback
      callback: callback,
      // "memoized" public interface
      facade: {
        get current() {
          return ref.value;
        },
        set current(value) {
          var last = ref.value;
          if (last !== value) {
            ref.value = value;
            ref.callback(value, last);
          }
        }
      }
    };
  })[0];
  // update callback
  ref.callback = callback;
  return ref.facade;
}
;// CONCATENATED MODULE: ./node_modules/use-callback-ref/dist/es2015/useMergeRef.js


/**
 * Merges two or more refs together providing a single interface to set their value
 * @param {RefObject|Ref} refs
 * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
 *
 * @see {@link mergeRefs} a version without buit-in memoization
 * @see https://github.com/theKashey/use-callback-ref#usemergerefs
 * @example
 * const Component = React.forwardRef((props, ref) => {
 *   const ownRef = useRef();
 *   const domRef = useMergeRefs([ref, ownRef]); // 👈 merge together
 *   return <div ref={domRef}>...</div>
 * }
 */
function useMergeRefs(refs, defaultValue) {
  return useCallbackRef(defaultValue || null, function (newValue) {
    return refs.forEach(function (ref) {
      return assignRef(ref, newValue);
    });
  });
}
;// CONCATENATED MODULE: ./node_modules/use-sidecar/dist/es2015/medium.js

function ItoI(a) {
  return a;
}
function innerCreateMedium(defaults, middleware) {
  if (middleware === void 0) {
    middleware = ItoI;
  }
  var buffer = [];
  var assigned = false;
  var medium = {
    read: function () {
      if (assigned) {
        throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
      }
      if (buffer.length) {
        return buffer[buffer.length - 1];
      }
      return defaults;
    },
    useMedium: function (data) {
      var item = middleware(data, assigned);
      buffer.push(item);
      return function () {
        buffer = buffer.filter(function (x) {
          return x !== item;
        });
      };
    },
    assignSyncMedium: function (cb) {
      assigned = true;
      while (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
      }
      buffer = {
        push: function (x) {
          return cb(x);
        },
        filter: function () {
          return buffer;
        }
      };
    },
    assignMedium: function (cb) {
      assigned = true;
      var pendingQueue = [];
      if (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
        pendingQueue = buffer;
      }
      var executeQueue = function () {
        var cbs = pendingQueue;
        pendingQueue = [];
        cbs.forEach(cb);
      };
      var cycle = function () {
        return Promise.resolve().then(executeQueue);
      };
      cycle();
      buffer = {
        push: function (x) {
          pendingQueue.push(x);
          cycle();
        },
        filter: function (filter) {
          pendingQueue = pendingQueue.filter(filter);
          return buffer;
        }
      };
    }
  };
  return medium;
}
function createMedium(defaults, middleware) {
  if (middleware === void 0) {
    middleware = ItoI;
  }
  return innerCreateMedium(defaults, middleware);
}
// eslint-disable-next-line @typescript-eslint/ban-types
function createSidecarMedium(options) {
  if (options === void 0) {
    options = {};
  }
  var medium = innerCreateMedium(null);
  medium.options = (0,tslib_es6.__assign)({
    async: true,
    ssr: false
  }, options);
  return medium;
}
;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/medium.js

var effectCar = createSidecarMedium();
;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/UI.js





var nothing = function () {
  return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */
var RemoveScroll = react.forwardRef(function (props, parentRef) {
  var ref = react.useRef(null);
  var _a = react.useState({
      onScrollCapture: nothing,
      onWheelCapture: nothing,
      onTouchMoveCapture: nothing
    }),
    callbacks = _a[0],
    setCallbacks = _a[1];
  var forwardProps = props.forwardProps,
    children = props.children,
    className = props.className,
    removeScrollBar = props.removeScrollBar,
    enabled = props.enabled,
    shards = props.shards,
    sideCar = props.sideCar,
    noIsolation = props.noIsolation,
    inert = props.inert,
    allowPinchZoom = props.allowPinchZoom,
    _b = props.as,
    Container = _b === void 0 ? 'div' : _b,
    gapMode = props.gapMode,
    rest = (0,tslib_es6.__rest)(props, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]);
  var SideCar = sideCar;
  var containerRef = useMergeRefs([ref, parentRef]);
  var containerProps = (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, rest), callbacks);
  return react.createElement(react.Fragment, null, enabled && react.createElement(SideCar, {
    sideCar: effectCar,
    removeScrollBar: removeScrollBar,
    shards: shards,
    noIsolation: noIsolation,
    inert: inert,
    setCallbacks: setCallbacks,
    allowPinchZoom: !!allowPinchZoom,
    lockRef: ref,
    gapMode: gapMode
  }), forwardProps ? react.cloneElement(react.Children.only(children), (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, containerProps), {
    ref: containerRef
  })) : react.createElement(Container, (0,tslib_es6.__assign)({}, containerProps, {
    className: className,
    ref: containerRef
  }), children));
});
RemoveScroll.defaultProps = {
  enabled: true,
  removeScrollBar: true,
  inert: false
};
RemoveScroll.classNames = {
  fullWidth: fullWidthClassName,
  zeroRight: zeroRightClassName
};

;// CONCATENATED MODULE: ./node_modules/use-sidecar/dist/es2015/exports.js


var SideCar = function (_a) {
  var sideCar = _a.sideCar,
    rest = (0,tslib_es6.__rest)(_a, ["sideCar"]);
  if (!sideCar) {
    throw new Error('Sidecar: please provide `sideCar` property to import the right car');
  }
  var Target = sideCar.read();
  if (!Target) {
    throw new Error('Sidecar medium not found');
  }
  return react.createElement(Target, (0,tslib_es6.__assign)({}, rest));
};
SideCar.isSideCarExport = true;
function exportSidecar(medium, exported) {
  medium.useMedium(exported);
  return SideCar;
}
;// CONCATENATED MODULE: ./node_modules/get-nonce/dist/es2015/index.js
var currentNonce;
var setNonce = function (nonce) {
  currentNonce = nonce;
};
var getNonce = function () {
  if (currentNonce) {
    return currentNonce;
  }
  if (true) {
    return __webpack_require__.nc;
  }
  return undefined;
};
;// CONCATENATED MODULE: ./node_modules/react-style-singleton/dist/es2015/singleton.js

function makeStyleTag() {
  if (!document) return null;
  var tag = document.createElement('style');
  tag.type = 'text/css';
  var nonce = getNonce();
  if (nonce) {
    tag.setAttribute('nonce', nonce);
  }
  return tag;
}
function injectStyles(tag, css) {
  // @ts-ignore
  if (tag.styleSheet) {
    // @ts-ignore
    tag.styleSheet.cssText = css;
  } else {
    tag.appendChild(document.createTextNode(css));
  }
}
function insertStyleTag(tag) {
  var head = document.head || document.getElementsByTagName('head')[0];
  head.appendChild(tag);
}
var stylesheetSingleton = function () {
  var counter = 0;
  var stylesheet = null;
  return {
    add: function (style) {
      if (counter == 0) {
        if (stylesheet = makeStyleTag()) {
          injectStyles(stylesheet, style);
          insertStyleTag(stylesheet);
        }
      }
      counter++;
    },
    remove: function () {
      counter--;
      if (!counter && stylesheet) {
        stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
        stylesheet = null;
      }
    }
  };
};
;// CONCATENATED MODULE: ./node_modules/react-style-singleton/dist/es2015/hook.js


/**
 * creates a hook to control style singleton
 * @see {@link styleSingleton} for a safer component version
 * @example
 * ```tsx
 * const useStyle = styleHookSingleton();
 * ///
 * useStyle('body { overflow: hidden}');
 */
var styleHookSingleton = function () {
  var sheet = stylesheetSingleton();
  return function (styles, isDynamic) {
    react.useEffect(function () {
      sheet.add(styles);
      return function () {
        sheet.remove();
      };
    }, [styles && isDynamic]);
  };
};
;// CONCATENATED MODULE: ./node_modules/react-style-singleton/dist/es2015/component.js

/**
 * create a Component to add styles on demand
 * - styles are added when first instance is mounted
 * - styles are removed when the last instance is unmounted
 * - changing styles in runtime does nothing unless dynamic is set. But with multiple components that can lead to the undefined behavior
 */
var styleSingleton = function () {
  var useStyle = styleHookSingleton();
  var Sheet = function (_a) {
    var styles = _a.styles,
      dynamic = _a.dynamic;
    useStyle(styles, dynamic);
    return null;
  };
  return Sheet;
};
;// CONCATENATED MODULE: ./node_modules/react-style-singleton/dist/es2015/index.js



;// CONCATENATED MODULE: ./node_modules/react-remove-scroll-bar/dist/es2015/utils.js
var zeroGap = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
};
var parse = function (x) {
  return parseInt(x || '', 10) || 0;
};
var getOffset = function (gapMode) {
  var cs = window.getComputedStyle(document.body);
  var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
  var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
  var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
  return [parse(left), parse(top), parse(right)];
};
var getGapWidth = function (gapMode) {
  if (gapMode === void 0) {
    gapMode = 'margin';
  }
  if (typeof window === 'undefined') {
    return zeroGap;
  }
  var offsets = getOffset(gapMode);
  var documentWidth = document.documentElement.clientWidth;
  var windowWidth = window.innerWidth;
  return {
    left: offsets[0],
    top: offsets[1],
    right: offsets[2],
    gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
  };
};
;// CONCATENATED MODULE: ./node_modules/react-remove-scroll-bar/dist/es2015/component.js




var Style = styleSingleton();
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var getStyles = function (_a, allowRelative, gapMode, important) {
  var left = _a.left,
    top = _a.top,
    right = _a.right,
    gap = _a.gap;
  if (gapMode === void 0) {
    gapMode = 'margin';
  }
  return "\n  .".concat(noScrollbarsClassName, " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([allowRelative && "position: relative ".concat(important, ";"), gapMode === 'margin' && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "), gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";")].filter(Boolean).join(''), "\n  }\n  \n  .").concat(zeroRightClassName, " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(zeroRightClassName, " .").concat(zeroRightClassName, " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " .").concat(fullWidthClassName, " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body {\n    ").concat(removedBarSizeVariable, ": ").concat(gap, "px;\n  }\n");
};
/**
 * Removes page scrollbar and blocks page scroll when mounted
 */
var RemoveScrollBar = function (props) {
  var noRelative = props.noRelative,
    noImportant = props.noImportant,
    _a = props.gapMode,
    gapMode = _a === void 0 ? 'margin' : _a;
  /*
   gap will be measured on every component mount
   however it will be used only by the "first" invocation
   due to singleton nature of <Style
   */
  var gap = react.useMemo(function () {
    return getGapWidth(gapMode);
  }, [gapMode]);
  return react.createElement(Style, {
    styles: getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '')
  });
};
;// CONCATENATED MODULE: ./node_modules/react-remove-scroll-bar/dist/es2015/index.js




;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/aggresiveCapture.js
var passiveSupported = false;
if (typeof window !== 'undefined') {
  try {
    var options = Object.defineProperty({}, 'passive', {
      get: function () {
        passiveSupported = true;
        return true;
      }
    });
    // @ts-ignore
    window.addEventListener('test', options, options);
    // @ts-ignore
    window.removeEventListener('test', options, options);
  } catch (err) {
    passiveSupported = false;
  }
}
var nonPassive = passiveSupported ? {
  passive: false
} : false;
;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/handleScroll.js
var alwaysContainsScroll = function (node) {
  // textarea will always _contain_ scroll inside self. It only can be hidden
  return node.tagName === 'TEXTAREA';
};
var elementCanBeScrolled = function (node, overflow) {
  var styles = window.getComputedStyle(node);
  return (
    // not-not-scrollable
    styles[overflow] !== 'hidden' &&
    // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !alwaysContainsScroll(node) && styles[overflow] === 'visible')
  );
};
var elementCouldBeVScrolled = function (node) {
  return elementCanBeScrolled(node, 'overflowY');
};
var elementCouldBeHScrolled = function (node) {
  return elementCanBeScrolled(node, 'overflowX');
};
var locationCouldBeScrolled = function (axis, node) {
  var ownerDocument = node.ownerDocument;
  var current = node;
  do {
    // Skip over shadow root
    if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) {
      current = current.host;
    }
    var isScrollable = elementCouldBeScrolled(axis, current);
    if (isScrollable) {
      var _a = getScrollVariables(axis, current),
        s = _a[1],
        d = _a[2];
      if (s > d) {
        return true;
      }
    }
    current = current.parentNode;
  } while (current && current !== ownerDocument.body);
  return false;
};
var getVScrollVariables = function (_a) {
  var scrollTop = _a.scrollTop,
    scrollHeight = _a.scrollHeight,
    clientHeight = _a.clientHeight;
  return [scrollTop, scrollHeight, clientHeight];
};
var getHScrollVariables = function (_a) {
  var scrollLeft = _a.scrollLeft,
    scrollWidth = _a.scrollWidth,
    clientWidth = _a.clientWidth;
  return [scrollLeft, scrollWidth, clientWidth];
};
var elementCouldBeScrolled = function (axis, node) {
  return axis === 'v' ? elementCouldBeVScrolled(node) : elementCouldBeHScrolled(node);
};
var getScrollVariables = function (axis, node) {
  return axis === 'v' ? getVScrollVariables(node) : getHScrollVariables(node);
};
var getDirectionFactor = function (axis, direction) {
  /**
   * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
   * and then increasingly negative as you scroll towards the end of the content.
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
   */
  return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var handleScroll = function (axis, endTarget, event, sourceDelta, noOverscroll) {
  var directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
  var delta = directionFactor * sourceDelta;
  // find scrollable target
  var target = event.target;
  var targetInLock = endTarget.contains(target);
  var shouldCancelScroll = false;
  var isDeltaPositive = delta > 0;
  var availableScroll = 0;
  var availableScrollTop = 0;
  do {
    var _a = getScrollVariables(axis, target),
      position = _a[0],
      scroll_1 = _a[1],
      capacity = _a[2];
    var elementScroll = scroll_1 - capacity - directionFactor * position;
    if (position || elementScroll) {
      if (elementCouldBeScrolled(axis, target)) {
        availableScroll += elementScroll;
        availableScrollTop += position;
      }
    }
    target = target.parentNode;
  } while (
  // portaled content
  !targetInLock && target !== document.body ||
  // self content
  targetInLock && (endTarget.contains(target) || endTarget === target));
  if (isDeltaPositive && (noOverscroll && availableScroll === 0 || !noOverscroll && delta > availableScroll)) {
    shouldCancelScroll = true;
  } else if (!isDeltaPositive && (noOverscroll && availableScrollTop === 0 || !noOverscroll && -delta > availableScrollTop)) {
    shouldCancelScroll = true;
  }
  return shouldCancelScroll;
};
;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/SideEffect.js






var getTouchXY = function (event) {
  return 'changedTouches' in event ? [event.changedTouches[0].clientX, event.changedTouches[0].clientY] : [0, 0];
};
var getDeltaXY = function (event) {
  return [event.deltaX, event.deltaY];
};
var extractRef = function (ref) {
  return ref && 'current' in ref ? ref.current : ref;
};
var deltaCompare = function (x, y) {
  return x[0] === y[0] && x[1] === y[1];
};
var generateStyle = function (id) {
  return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var idCounter = 0;
var lockStack = [];
function RemoveScrollSideCar(props) {
  var shouldPreventQueue = react.useRef([]);
  var touchStartRef = react.useRef([0, 0]);
  var activeAxis = react.useRef();
  var id = react.useState(idCounter++)[0];
  var Style = react.useState(styleSingleton)[0];
  var lastProps = react.useRef(props);
  react.useEffect(function () {
    lastProps.current = props;
  }, [props]);
  react.useEffect(function () {
    if (props.inert) {
      document.body.classList.add("block-interactivity-".concat(id));
      var allow_1 = (0,tslib_es6.__spreadArray)([props.lockRef.current], (props.shards || []).map(extractRef), true).filter(Boolean);
      allow_1.forEach(function (el) {
        return el.classList.add("allow-interactivity-".concat(id));
      });
      return function () {
        document.body.classList.remove("block-interactivity-".concat(id));
        allow_1.forEach(function (el) {
          return el.classList.remove("allow-interactivity-".concat(id));
        });
      };
    }
    return;
  }, [props.inert, props.lockRef.current, props.shards]);
  var shouldCancelEvent = react.useCallback(function (event, parent) {
    if ('touches' in event && event.touches.length === 2) {
      return !lastProps.current.allowPinchZoom;
    }
    var touch = getTouchXY(event);
    var touchStart = touchStartRef.current;
    var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
    var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
    var currentAxis;
    var target = event.target;
    var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
    // allow horizontal touch move on Range inputs. They will not cause any scroll
    if ('touches' in event && moveDirection === 'h' && target.type === 'range') {
      return false;
    }
    var canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
    if (!canBeScrolledInMainDirection) {
      return true;
    }
    if (canBeScrolledInMainDirection) {
      currentAxis = moveDirection;
    } else {
      currentAxis = moveDirection === 'v' ? 'h' : 'v';
      canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
      // other axis might be not scrollable
    }

    if (!canBeScrolledInMainDirection) {
      return false;
    }
    if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) {
      activeAxis.current = currentAxis;
    }
    if (!currentAxis) {
      return true;
    }
    var cancelingAxis = activeAxis.current || currentAxis;
    return handleScroll(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
  }, []);
  var shouldPrevent = react.useCallback(function (_event) {
    var event = _event;
    if (!lockStack.length || lockStack[lockStack.length - 1] !== Style) {
      // not the last active
      return;
    }
    var delta = 'deltaY' in event ? getDeltaXY(event) : getTouchXY(event);
    var sourceEvent = shouldPreventQueue.current.filter(function (e) {
      return e.name === event.type && e.target === event.target && deltaCompare(e.delta, delta);
    })[0];
    // self event, and should be canceled
    if (sourceEvent && sourceEvent.should) {
      if (event.cancelable) {
        event.preventDefault();
      }
      return;
    }
    // outside or shard event
    if (!sourceEvent) {
      var shardNodes = (lastProps.current.shards || []).map(extractRef).filter(Boolean).filter(function (node) {
        return node.contains(event.target);
      });
      var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
      if (shouldStop) {
        if (event.cancelable) {
          event.preventDefault();
        }
      }
    }
  }, []);
  var shouldCancel = react.useCallback(function (name, delta, target, should) {
    var event = {
      name: name,
      delta: delta,
      target: target,
      should: should
    };
    shouldPreventQueue.current.push(event);
    setTimeout(function () {
      shouldPreventQueue.current = shouldPreventQueue.current.filter(function (e) {
        return e !== event;
      });
    }, 1);
  }, []);
  var scrollTouchStart = react.useCallback(function (event) {
    touchStartRef.current = getTouchXY(event);
    activeAxis.current = undefined;
  }, []);
  var scrollWheel = react.useCallback(function (event) {
    shouldCancel(event.type, getDeltaXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
  }, []);
  var scrollTouchMove = react.useCallback(function (event) {
    shouldCancel(event.type, getTouchXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
  }, []);
  react.useEffect(function () {
    lockStack.push(Style);
    props.setCallbacks({
      onScrollCapture: scrollWheel,
      onWheelCapture: scrollWheel,
      onTouchMoveCapture: scrollTouchMove
    });
    document.addEventListener('wheel', shouldPrevent, nonPassive);
    document.addEventListener('touchmove', shouldPrevent, nonPassive);
    document.addEventListener('touchstart', scrollTouchStart, nonPassive);
    return function () {
      lockStack = lockStack.filter(function (inst) {
        return inst !== Style;
      });
      document.removeEventListener('wheel', shouldPrevent, nonPassive);
      document.removeEventListener('touchmove', shouldPrevent, nonPassive);
      document.removeEventListener('touchstart', scrollTouchStart, nonPassive);
    };
  }, []);
  var removeScrollBar = props.removeScrollBar,
    inert = props.inert;
  return react.createElement(react.Fragment, null, inert ? react.createElement(Style, {
    styles: generateStyle(id)
  }) : null, removeScrollBar ? react.createElement(RemoveScrollBar, {
    gapMode: props.gapMode
  }) : null);
}
;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/sidecar.js



/* harmony default export */ var sidecar = (exportSidecar(effectCar, RemoveScrollSideCar));
;// CONCATENATED MODULE: ./node_modules/react-remove-scroll/dist/es2015/Combination.js




var ReactRemoveScroll = react.forwardRef(function (props, ref) {
  return react.createElement(RemoveScroll, (0,tslib_es6.__assign)({}, props, {
    ref: ref,
    sideCar: sidecar
  }));
});
ReactRemoveScroll.classNames = RemoveScroll.classNames;
/* harmony default export */ var Combination = (ReactRemoveScroll);
;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-menu/dist/index.module.js





















const x = ["Enter", " "],
  index_module_b = ["ArrowUp", "PageDown", "End"],
  index_module_R = ["ArrowDown", "PageUp", "Home", ...index_module_b],
  _ = {
    ltr: [...x, "ArrowRight"],
    rtl: [...x, "ArrowLeft"]
  },
  y = {
    ltr: ["ArrowLeft"],
    rtl: ["ArrowRight"]
  },
  [I, k, P] = (0,react_collection_dist_index_module/* createCollection */.B)("Menu"),
  [D, S] = (0,react_context_dist_index_module/* createContextScope */.b)("Menu", [P, dist_index_module_l, index_module_v]);

const O = dist_index_module_l(),
  T = index_module_v(),
  [L, A] = D("Menu");
const Menu = e => {
  const {
      __scopeMenu: n,
      open: o = !1,
      children: u,
      onOpenChange: c,
      modal: i = !0
    } = e,
    s = O(n),
    [l, d] = react.useState(null),
    p = react.useRef(!1),
    f = (0,dist_index_module/* useCallbackRef */.W)(c),
    m = useDirection(l, e.dir);
  return react.useEffect(() => {
    const e = () => {
        p.current = !0, document.addEventListener("pointerdown", n, {
          capture: !0,
          once: !0
        }), document.addEventListener("pointermove", n, {
          capture: !0,
          once: !0
        });
      },
      n = () => p.current = !1;
    return document.addEventListener("keydown", e, {
      capture: !0
    }), () => {
      document.removeEventListener("keydown", e, {
        capture: !0
      }), document.removeEventListener("pointerdown", n, {
        capture: !0
      }), document.removeEventListener("pointermove", n, {
        capture: !0
      });
    };
  }, []), /*#__PURE__*/react.createElement(react_popper_dist_index_module_Root, s, /*#__PURE__*/react.createElement(L, {
    scope: n,
    isSubmenu: !1,
    isUsingKeyboardRef: p,
    dir: m,
    open: o,
    onOpenChange: f,
    content: l,
    onContentChange: d,
    onRootClose: react.useCallback(() => f(!1), [f]),
    modal: i
  }, u));
}; /*#__PURE__*/
const MenuSub = n => {
  const {
      __scopeMenu: r,
      children: o,
      open: u = !1,
      onOpenChange: c
    } = n,
    i = A("MenuSub", r),
    s = O(r),
    [l, d] = react.useState(null),
    [p, f] = react.useState(null),
    m = (0,dist_index_module/* useCallbackRef */.W)(c);
  return react.useEffect(() => (!1 === i.open && m(!1), () => m(!1)), [i.open, m]), /*#__PURE__*/react.createElement(react_popper_dist_index_module_Root, s, /*#__PURE__*/react.createElement(L, {
    scope: r,
    isSubmenu: !0,
    isUsingKeyboardRef: i.isUsingKeyboardRef,
    dir: i.dir,
    open: u,
    onOpenChange: m,
    content: p,
    onContentChange: f,
    onRootClose: i.onRootClose,
    contentId: (0,index_module/* useId */.M)(),
    trigger: l,
    onTriggerChange: d,
    triggerId: (0,index_module/* useId */.M)(),
    modal: !1
  }, o));
}; /*#__PURE__*/
const MenuAnchor = /*#__PURE__*/react.forwardRef((e, n) => {
  const {
      __scopeMenu: t,
      ...r
    } = e,
    o = O(t); /*#__PURE__*/
  return react.createElement(Anchor, (0,esm_extends/* default */.Z)({}, o, r, {
    ref: n
  }));
}); /*#__PURE__*/
const [index_module_F, K] = D("MenuContent");
const MenuContent = /*#__PURE__*/react.forwardRef((e, n) => {
  const {
      forceMount: t,
      ...r
    } = e,
    o = A("MenuContent", e.__scopeMenu); /*#__PURE__*/
  return react.createElement(I.Provider, {
    scope: e.__scopeMenu
  }, /*#__PURE__*/react.createElement(react_presence_dist_index_module/* Presence */.z, {
    present: t || o.open
  }, /*#__PURE__*/react.createElement(I.Slot, {
    scope: e.__scopeMenu
  }, o.isSubmenu ? /*#__PURE__*/react.createElement(X, (0,esm_extends/* default */.Z)({}, r, {
    ref: n
  })) : /*#__PURE__*/react.createElement(G, (0,esm_extends/* default */.Z)({}, r, {
    ref: n
  })))));
});
const G = /*#__PURE__*/react.forwardRef((e, n) => A("MenuContent", e.__scopeMenu).modal ? /*#__PURE__*/react.createElement(U, (0,esm_extends/* default */.Z)({}, e, {
    ref: n
  })) : /*#__PURE__*/react.createElement(V, (0,esm_extends/* default */.Z)({}, e, {
    ref: n
  }))),
  U = /*#__PURE__*/react.forwardRef((e, n) => {
    const t = A("MenuContent", e.__scopeMenu),
      r = react.useRef(null),
      o = (0,react_compose_refs_dist_index_module/* useComposedRefs */.e)(n, r);
    return react.useEffect(() => {
      const e = r.current;
      if (e) return hideOthers(e);
    }, []), /*#__PURE__*/react.createElement(B, (0,esm_extends/* default */.Z)({}, e, {
      ref: o,
      trapFocus: t.open,
      disableOutsidePointerEvents: t.open,
      disableOutsideScroll: !0,
      onFocusOutside: (0,primitive_dist_index_module/* composeEventHandlers */.M)(e.onFocusOutside, e => e.preventDefault(), {
        checkForDefaultPrevented: !1
      }),
      onDismiss: () => t.onOpenChange(!1)
    }));
  }),
  V = /*#__PURE__*/react.forwardRef((e, n) => {
    const t = A("MenuContent", e.__scopeMenu); /*#__PURE__*/
    return react.createElement(B, (0,esm_extends/* default */.Z)({}, e, {
      ref: n,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => t.onOpenChange(!1)
    }));
  }),
  X = /*#__PURE__*/react.forwardRef((e, n) => {
    const t = A("MenuContent", e.__scopeMenu),
      r = react.useRef(null),
      o = (0,react_compose_refs_dist_index_module/* useComposedRefs */.e)(n, r);
    return t.isSubmenu ? /*#__PURE__*/react.createElement(B, (0,esm_extends/* default */.Z)({
      id: t.contentId,
      "aria-labelledby": t.triggerId
    }, e, {
      ref: o,
      align: "start",
      side: "rtl" === t.dir ? "left" : "right",
      portalled: !0,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      trapFocus: !1,
      onOpenAutoFocus: e => {
        var n;
        t.isUsingKeyboardRef.current && (null === (n = r.current) || void 0 === n || n.focus()), e.preventDefault();
      },
      onCloseAutoFocus: e => e.preventDefault(),
      onFocusOutside: (0,primitive_dist_index_module/* composeEventHandlers */.M)(e.onFocusOutside, e => {
        e.target !== t.trigger && t.onOpenChange(!1);
      }),
      onEscapeKeyDown: (0,primitive_dist_index_module/* composeEventHandlers */.M)(e.onEscapeKeyDown, t.onRootClose),
      onKeyDown: (0,primitive_dist_index_module/* composeEventHandlers */.M)(e.onKeyDown, e => {
        const n = e.currentTarget.contains(e.target),
          r = y[t.dir].includes(e.key);
        var o;
        n && r && (t.onOpenChange(!1), null === (o = t.trigger) || void 0 === o || o.focus(), e.preventDefault());
      })
    })) : null;
  }),
  B = /*#__PURE__*/react.forwardRef((e, t) => {
    const {
        __scopeMenu: r,
        loop: u = !1,
        trapFocus: i,
        onOpenAutoFocus: s,
        onCloseAutoFocus: l,
        disableOutsidePointerEvents: f,
        onEscapeKeyDown: v,
        onPointerDownOutside: g,
        onFocusOutside: h,
        onInteractOutside: x,
        onDismiss: _,
        disableOutsideScroll: y,
        allowPinchZoom: I,
        portalled: P,
        ...D
      } = e,
      S = A("MenuContent", r),
      L = O(r),
      K = T(r),
      G = k(r),
      [U, V] = react.useState(null),
      X = react.useRef(null),
      B = (0,react_compose_refs_dist_index_module/* useComposedRefs */.e)(t, X, S.onContentChange),
      Y = react.useRef(0),
      Z = react.useRef(""),
      z = react.useRef(0),
      H = react.useRef(null),
      W = react.useRef("right"),
      q = react.useRef(0),
      N = P ? Portal : react.Fragment,
      Q = y ? Combination : react.Fragment,
      $ = y ? {
        allowPinchZoom: I
      } : void 0,
      ee = e => {
        var n, t;
        const r = Z.current + e,
          o = G().filter(e => !e.disabled),
          u = document.activeElement,
          c = null === (n = o.find(e => e.ref.current === u)) || void 0 === n ? void 0 : n.textValue,
          a = function (e, n, t) {
            const r = n.length > 1 && Array.from(n).every(e => e === n[0]) ? n[0] : n,
              o = t ? e.indexOf(t) : -1;
            let u = (c = e, a = Math.max(o, 0), c.map((e, n) => c[(a + n) % c.length]));
            var c, a;
            1 === r.length && (u = u.filter(e => e !== t));
            const i = u.find(e => e.toLowerCase().startsWith(r.toLowerCase()));
            return i !== t ? i : void 0;
          }(o.map(e => e.textValue), r, c),
          i = null === (t = o.find(e => e.textValue === a)) || void 0 === t ? void 0 : t.ref.current;
        !function e(n) {
          Z.current = n, window.clearTimeout(Y.current), "" !== n && (Y.current = window.setTimeout(() => e(""), 1e3));
        }(r), i && setTimeout(() => i.focus());
      };
    react.useEffect(() => () => window.clearTimeout(Y.current), []), useFocusGuards();
    const ne = react.useCallback(e => {
      var n, t;
      return W.current === (null === (n = H.current) || void 0 === n ? void 0 : n.side) && function (e, n) {
        if (!n) return !1;
        return function (e, n) {
          const {
            x: t,
            y: r
          } = e;
          let o = !1;
          for (let e = 0, u = n.length - 1; e < n.length; u = e++) {
            const c = n[e].x,
              a = n[e].y,
              i = n[u].x,
              s = n[u].y;
            a > r != s > r && t < (i - c) * (r - a) / (s - a) + c && (o = !o);
          }
          return o;
        }({
          x: e.clientX,
          y: e.clientY
        }, n);
      }(e, null === (t = H.current) || void 0 === t ? void 0 : t.area);
    }, []); /*#__PURE__*/
    return react.createElement(N, null, /*#__PURE__*/react.createElement(Q, $, /*#__PURE__*/react.createElement(index_module_F, {
      scope: r,
      searchRef: Z,
      onItemEnter: react.useCallback(e => {
        ne(e) && e.preventDefault();
      }, [ne]),
      onItemLeave: react.useCallback(e => {
        var n;
        ne(e) || (null === (n = X.current) || void 0 === n || n.focus(), V(null));
      }, [ne]),
      onTriggerLeave: react.useCallback(e => {
        ne(e) && e.preventDefault();
      }, [ne]),
      pointerGraceTimerRef: z,
      onPointerGraceIntentChange: react.useCallback(e => {
        H.current = e;
      }, [])
    }, /*#__PURE__*/react.createElement(FocusScope, {
      asChild: !0,
      trapped: i,
      onMountAutoFocus: (0,primitive_dist_index_module/* composeEventHandlers */.M)(s, e => {
        var n;
        e.preventDefault(), null === (n = X.current) || void 0 === n || n.focus();
      }),
      onUnmountAutoFocus: l
    }, /*#__PURE__*/react.createElement(DismissableLayer, {
      asChild: !0,
      disableOutsidePointerEvents: f,
      onEscapeKeyDown: v,
      onPointerDownOutside: g,
      onFocusOutside: h,
      onInteractOutside: x,
      onDismiss: _
    }, /*#__PURE__*/react.createElement(index_module_Root, (0,esm_extends/* default */.Z)({
      asChild: !0
    }, K, {
      dir: S.dir,
      orientation: "vertical",
      loop: u,
      currentTabStopId: U,
      onCurrentTabStopIdChange: V,
      onEntryFocus: e => {
        S.isUsingKeyboardRef.current || e.preventDefault();
      }
    }), /*#__PURE__*/react.createElement(Content, (0,esm_extends/* default */.Z)({
      role: "menu",
      "aria-orientation": "vertical",
      "data-state": j(S.open),
      dir: S.dir
    }, L, D, {
      ref: B,
      style: {
        outline: "none",
        ...D.style
      },
      onKeyDown: (0,primitive_dist_index_module/* composeEventHandlers */.M)(D.onKeyDown, e => {
        const n = e.target,
          t = e.currentTarget.contains(n),
          r = e.ctrlKey || e.altKey || e.metaKey,
          o = 1 === e.key.length;
        t && ("Tab" === e.key && e.preventDefault(), !r && o && ee(e.key));
        const u = X.current;
        if (e.target !== u) return;
        if (!index_module_R.includes(e.key)) return;
        e.preventDefault();
        const c = G().filter(e => !e.disabled).map(e => e.ref.current);
        index_module_b.includes(e.key) && c.reverse(), function (e) {
          const n = document.activeElement;
          for (const t of e) {
            if (t === n) return;
            if (t.focus(), document.activeElement !== n) return;
          }
        }(c);
      }),
      onBlur: (0,primitive_dist_index_module/* composeEventHandlers */.M)(e.onBlur, e => {
        e.currentTarget.contains(e.target) || (window.clearTimeout(Y.current), Z.current = "");
      }),
      onPointerMove: (0,primitive_dist_index_module/* composeEventHandlers */.M)(e.onPointerMove, J(e => {
        const n = e.target,
          t = q.current !== e.clientX;
        if (e.currentTarget.contains(n) && t) {
          const n = e.clientX > q.current ? "right" : "left";
          W.current = n, q.current = e.clientX;
        }
      }))
    }))))))));
  });
const MenuGroup = /*#__PURE__*/(/* unused pure expression or super */ null && (E.forwardRef((e, n) => {
  const {
    __scopeMenu: t,
    ...r
  } = e; /*#__PURE__*/
  return E.createElement(s.div, w({
    role: "group"
  }, r, {
    ref: n
  }));
}))); /*#__PURE__*/
const MenuLabel = /*#__PURE__*/(/* unused pure expression or super */ null && (E.forwardRef((e, n) => {
  const {
    __scopeMenu: t,
    ...r
  } = e; /*#__PURE__*/
  return E.createElement(s.div, w({}, r, {
    ref: n
  }));
}))); /*#__PURE__*/
const MenuItem = /*#__PURE__*/react.forwardRef((e, n) => {
  const {
      disabled: t = !1,
      onSelect: r,
      ...o
    } = e,
    u = react.useRef(null),
    c = A("MenuItem", e.__scopeMenu),
    a = K("MenuItem", e.__scopeMenu),
    i = (0,react_compose_refs_dist_index_module/* useComposedRefs */.e)(n, u),
    s = react.useRef(!1); /*#__PURE__*/
  return react.createElement(Y, (0,esm_extends/* default */.Z)({}, o, {
    ref: i,
    disabled: t,
    onClick: (0,primitive_dist_index_module/* composeEventHandlers */.M)(e.onClick, () => {
      const e = u.current;
      if (!t && e) {
        const n = new Event("menu.itemSelect", {
          bubbles: !0,
          cancelable: !0
        });
        e.addEventListener("menu.itemSelect", e => null == r ? void 0 : r(e), {
          once: !0
        }), e.dispatchEvent(n), n.defaultPrevented ? s.current = !1 : c.onRootClose();
      }
    }),
    onPointerDown: n => {
      var t;
      null === (t = e.onPointerDown) || void 0 === t || t.call(e, n), s.current = !0;
    },
    onPointerUp: (0,primitive_dist_index_module/* composeEventHandlers */.M)(e.onPointerUp, e => {
      var n;
      s.current || null === (n = e.currentTarget) || void 0 === n || n.click();
    }),
    onKeyDown: (0,primitive_dist_index_module/* composeEventHandlers */.M)(e.onKeyDown, e => {
      const n = "" !== a.searchRef.current;
      t || n && " " === e.key || x.includes(e.key) && (e.currentTarget.click(), e.preventDefault());
    })
  }));
}); /*#__PURE__*/
const MenuSubTrigger = /*#__PURE__*/(/* unused pure expression or super */ null && (E.forwardRef((e, n) => {
  const t = A("MenuSubTrigger", e.__scopeMenu),
    r = K("MenuSubTrigger", e.__scopeMenu),
    o = E.useRef(null),
    {
      pointerGraceTimerRef: u,
      onPointerGraceIntentChange: c
    } = r,
    a = {
      __scopeMenu: e.__scopeMenu
    },
    i = E.useCallback(() => {
      o.current && window.clearTimeout(o.current), o.current = null;
    }, []);
  return E.useEffect(() => i, [i]), E.useEffect(() => {
    const e = u.current;
    return () => {
      window.clearTimeout(e), c(null);
    };
  }, [u, c]), t.isSubmenu ? /*#__PURE__*/E.createElement(MenuAnchor, w({
    asChild: !0
  }, a), /*#__PURE__*/E.createElement(Y, w({
    id: t.triggerId,
    "aria-haspopup": "menu",
    "aria-expanded": t.open,
    "aria-controls": t.contentId,
    "data-state": j(t.open)
  }, e, {
    ref: v(n, t.onTriggerChange),
    onClick: n => {
      var r;
      null === (r = e.onClick) || void 0 === r || r.call(e, n), e.disabled || n.defaultPrevented || (n.currentTarget.focus(), t.open || t.onOpenChange(!0));
    },
    onPointerMove: M(e.onPointerMove, J(n => {
      r.onItemEnter(n), n.defaultPrevented || e.disabled || t.open || o.current || (r.onPointerGraceIntentChange(null), o.current = window.setTimeout(() => {
        t.onOpenChange(!0), i();
      }, 100));
    })),
    onPointerLeave: M(e.onPointerLeave, J(e => {
      var n;
      i();
      const o = null === (n = t.content) || void 0 === n ? void 0 : n.getBoundingClientRect();
      if (o) {
        var c;
        const n = null === (c = t.content) || void 0 === c ? void 0 : c.dataset.side,
          a = "right" === n,
          i = a ? -5 : 5,
          s = o[a ? "left" : "right"],
          l = o[a ? "right" : "left"];
        r.onPointerGraceIntentChange({
          area: [{
            x: e.clientX + i,
            y: e.clientY
          }, {
            x: s,
            y: o.top
          }, {
            x: l,
            y: o.top
          }, {
            x: l,
            y: o.bottom
          }, {
            x: s,
            y: o.bottom
          }],
          side: n
        }), window.clearTimeout(u.current), u.current = window.setTimeout(() => r.onPointerGraceIntentChange(null), 300);
      } else {
        if (r.onTriggerLeave(e), e.defaultPrevented) return;
        r.onPointerGraceIntentChange(null);
      }
    })),
    onKeyDown: M(e.onKeyDown, n => {
      const o = "" !== r.searchRef.current;
      var u;
      e.disabled || o && " " === n.key || _[t.dir].includes(n.key) && (t.onOpenChange(!0), null === (u = t.content) || void 0 === u || u.focus(), n.preventDefault());
    })
  }))) : null;
}))); /*#__PURE__*/
const Y = /*#__PURE__*/react.forwardRef((e, n) => {
  const {
      __scopeMenu: t,
      disabled: r = !1,
      textValue: u,
      ...c
    } = e,
    a = K("MenuItem", t),
    i = T(t),
    l = react.useRef(null),
    d = (0,react_compose_refs_dist_index_module/* useComposedRefs */.e)(n, l),
    [p, f] = react.useState("");
  return react.useEffect(() => {
    const e = l.current;
    var n;
    e && f((null !== (n = e.textContent) && void 0 !== n ? n : "").trim());
  }, [c.children]), /*#__PURE__*/react.createElement(I.ItemSlot, {
    scope: t,
    disabled: r,
    textValue: null != u ? u : p
  }, /*#__PURE__*/react.createElement(Item, (0,esm_extends/* default */.Z)({
    asChild: !0
  }, i, {
    focusable: !r
  }), /*#__PURE__*/react.createElement(react_primitive_dist_index_module/* Primitive.div */.W.div, (0,esm_extends/* default */.Z)({
    role: "menuitem",
    "aria-disabled": r || void 0,
    "data-disabled": r ? "" : void 0
  }, c, {
    ref: d,
    onPointerMove: (0,primitive_dist_index_module/* composeEventHandlers */.M)(e.onPointerMove, J(e => {
      if (r) a.onItemLeave(e);else if (a.onItemEnter(e), !e.defaultPrevented) {
        e.currentTarget.focus();
      }
    })),
    onPointerLeave: (0,primitive_dist_index_module/* composeEventHandlers */.M)(e.onPointerLeave, J(e => a.onItemLeave(e)))
  }))));
});
const MenuCheckboxItem = /*#__PURE__*/(/* unused pure expression or super */ null && (E.forwardRef((e, n) => {
  const {
    checked: t = !1,
    onCheckedChange: r,
    ...o
  } = e; /*#__PURE__*/
  return E.createElement(H, {
    scope: e.__scopeMenu,
    checked: t
  }, /*#__PURE__*/E.createElement(MenuItem, w({
    role: "menuitemcheckbox",
    "aria-checked": t
  }, o, {
    ref: n,
    "data-state": q(t),
    onSelect: M(o.onSelect, () => null == r ? void 0 : r(!t), {
      checkForDefaultPrevented: !1
    })
  })));
}))); /*#__PURE__*/
const [Z, z] = D("MenuRadioGroup", {
  value: void 0,
  onValueChange: () => {}
});
const MenuRadioGroup = /*#__PURE__*/(/* unused pure expression or super */ null && (E.forwardRef((e, n) => {
  const {
      value: r,
      onValueChange: o,
      ...u
    } = e,
    c = t(o); /*#__PURE__*/
  return E.createElement(Z, {
    scope: e.__scopeMenu,
    value: r,
    onValueChange: c
  }, /*#__PURE__*/E.createElement(MenuGroup, w({}, u, {
    ref: n
  })));
}))); /*#__PURE__*/
const MenuRadioItem = /*#__PURE__*/(/* unused pure expression or super */ null && (E.forwardRef((e, n) => {
  const {
      value: t,
      ...r
    } = e,
    o = z("MenuRadioItem", e.__scopeMenu),
    u = t === o.value; /*#__PURE__*/
  return E.createElement(H, {
    scope: e.__scopeMenu,
    checked: u
  }, /*#__PURE__*/E.createElement(MenuItem, w({
    role: "menuitemradio",
    "aria-checked": u
  }, r, {
    ref: n,
    "data-state": q(u),
    onSelect: M(r.onSelect, () => {
      var e;
      return null === (e = o.onValueChange) || void 0 === e ? void 0 : e.call(o, t);
    }, {
      checkForDefaultPrevented: !1
    })
  })));
}))); /*#__PURE__*/
const [H, W] = D("MenuItemIndicator", {
  checked: !1
});
const MenuItemIndicator = /*#__PURE__*/(/* unused pure expression or super */ null && (E.forwardRef((e, n) => {
  const {
      __scopeMenu: t,
      forceMount: r,
      ...o
    } = e,
    u = W("MenuItemIndicator", t); /*#__PURE__*/
  return E.createElement(l, {
    present: r || u.checked
  }, /*#__PURE__*/E.createElement(s.span, w({}, o, {
    ref: n,
    "data-state": q(u.checked)
  })));
}))); /*#__PURE__*/
const MenuSeparator = /*#__PURE__*/(/* unused pure expression or super */ null && (E.forwardRef((e, n) => {
  const {
    __scopeMenu: t,
    ...r
  } = e; /*#__PURE__*/
  return E.createElement(s.div, w({
    role: "separator",
    "aria-orientation": "horizontal"
  }, r, {
    ref: n
  }));
}))); /*#__PURE__*/
const MenuArrow = /*#__PURE__*/react.forwardRef((e, n) => {
  const {
      __scopeMenu: t,
      ...r
    } = e,
    o = O(t); /*#__PURE__*/
  return react.createElement(index_module_Arrow, (0,esm_extends/* default */.Z)({}, o, r, {
    ref: n
  }));
}); /*#__PURE__*/
function j(e) {
  return e ? "open" : "closed";
}
function q(e) {
  return e ? "checked" : "unchecked";
}
function J(e) {
  return n => "mouse" === n.pointerType ? e(n) : void 0;
}
const react_menu_dist_index_module_Root = Menu;
const Sub = MenuSub;
const index_module_Anchor = MenuAnchor;
const SubTrigger = (/* unused pure expression or super */ null && (MenuSubTrigger));
const index_module_Content = MenuContent;
const Group = (/* unused pure expression or super */ null && (MenuGroup));
const Label = (/* unused pure expression or super */ null && (MenuLabel));
const index_module_Item = MenuItem;
const CheckboxItem = (/* unused pure expression or super */ null && (MenuCheckboxItem));
const RadioGroup = (/* unused pure expression or super */ null && (MenuRadioGroup));
const RadioItem = (/* unused pure expression or super */ null && (MenuRadioItem));
const ItemIndicator = (/* unused pure expression or super */ null && (MenuItemIndicator));
const Separator = (/* unused pure expression or super */ null && (MenuSeparator));
const dist_index_module_Arrow = MenuArrow;
;// CONCATENATED MODULE: ./node_modules/@radix-ui/react-dropdown-menu/dist/index.module.js










const [react_dropdown_menu_dist_index_module_s, react_dropdown_menu_dist_index_module_i] = (0,react_context_dist_index_module/* createContextScope */.b)("DropdownMenu", [S]);

const react_dropdown_menu_dist_index_module_l = S(),
  [dist_index_module_m, dist_index_module_w] = react_dropdown_menu_dist_index_module_s("DropdownMenu");
const DropdownMenu = e => {
  const {
      __scopeDropdownMenu: n,
      children: r,
      open: p,
      defaultOpen: d,
      onOpenChange: a
    } = e,
    s = index_module_M("DropdownMenu", n),
    i = react_dropdown_menu_dist_index_module_l(n),
    [w = !1, D] = (0,react_use_controllable_state_dist_index_module/* useControllableState */.T)({
      prop: p,
      defaultProp: d,
      onChange: a
    }),
    g = react.useCallback(() => D(e => !e), [D]);
  return s.isInsideContent ? /*#__PURE__*/react.createElement(dist_index_module_m, {
    scope: n,
    isRootMenu: !1,
    open: w,
    onOpenChange: D,
    onOpenToggle: g
  }, /*#__PURE__*/react.createElement(Sub, (0,esm_extends/* default */.Z)({}, i, {
    open: w,
    onOpenChange: D
  }), r)) : /*#__PURE__*/react.createElement(react_dropdown_menu_dist_index_module_f, (0,esm_extends/* default */.Z)({}, e, {
    open: w,
    onOpenChange: D,
    onOpenToggle: g
  }), r);
}; /*#__PURE__*/
const react_dropdown_menu_dist_index_module_f = n => {
  const {
      __scopeDropdownMenu: r,
      children: t,
      dir: p,
      open: d,
      onOpenChange: a,
      onOpenToggle: s,
      modal: i = !0
    } = n,
    w = react_dropdown_menu_dist_index_module_l(r),
    f = react.useRef(null); /*#__PURE__*/
  return react.createElement(dist_index_module_m, {
    scope: r,
    isRootMenu: !0,
    triggerId: (0,index_module/* useId */.M)(),
    triggerRef: f,
    contentId: (0,index_module/* useId */.M)(),
    open: d,
    onOpenChange: a,
    onOpenToggle: s,
    modal: i
  }, /*#__PURE__*/react.createElement(react_menu_dist_index_module_Root, (0,esm_extends/* default */.Z)({}, w, {
    open: d,
    onOpenChange: a,
    dir: p,
    modal: i
  }), t));
};
const DropdownMenuTrigger = /*#__PURE__*/react.forwardRef((e, n) => {
  const {
      __scopeDropdownMenu: t,
      disabled: p = !1,
      ...s
    } = e,
    i = dist_index_module_w("DropdownMenuTrigger", t),
    m = react_dropdown_menu_dist_index_module_l(t);
  return i.isRootMenu ? /*#__PURE__*/react.createElement(index_module_Anchor, (0,esm_extends/* default */.Z)({
    asChild: !0
  }, m), /*#__PURE__*/react.createElement(react_primitive_dist_index_module/* Primitive.button */.W.button, (0,esm_extends/* default */.Z)({
    type: "button",
    id: i.triggerId,
    "aria-haspopup": "menu",
    "aria-expanded": !!i.open || void 0,
    "aria-controls": i.open ? i.contentId : void 0,
    "data-state": i.open ? "open" : "closed",
    "data-disabled": p ? "" : void 0,
    disabled: p
  }, s, {
    ref: (0,react_compose_refs_dist_index_module/* composeRefs */.F)(n, i.triggerRef),
    onPointerDown: (0,primitive_dist_index_module/* composeEventHandlers */.M)(e.onPointerDown, e => {
      p || 0 !== e.button || !1 !== e.ctrlKey || (i.open || e.preventDefault(), i.onOpenToggle());
    }),
    onKeyDown: (0,primitive_dist_index_module/* composeEventHandlers */.M)(e.onKeyDown, e => {
      p || (["Enter", " "].includes(e.key) && i.onOpenToggle(), "ArrowDown" === e.key && i.onOpenChange(!0), [" ", "ArrowDown"].includes(e.key) && e.preventDefault());
    })
  }))) : null;
}); /*#__PURE__*/
const [index_module_D, index_module_M] = react_dropdown_menu_dist_index_module_s("DropdownMenuContent", {
  isInsideContent: !1
});
const DropdownMenuContent = /*#__PURE__*/react.forwardRef((e, n) => {
  const {
      __scopeDropdownMenu: r,
      ...t
    } = e,
    p = dist_index_module_w("DropdownMenuContent", r),
    d = react_dropdown_menu_dist_index_module_l(r),
    a = {
      ...t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)"
      }
    }; /*#__PURE__*/
  return react.createElement(index_module_D, {
    scope: r,
    isInsideContent: !0
  }, p.isRootMenu ? /*#__PURE__*/react.createElement(index_module_g, (0,esm_extends/* default */.Z)({
    __scopeDropdownMenu: r
  }, a, {
    ref: n
  })) : /*#__PURE__*/react.createElement(index_module_Content, (0,esm_extends/* default */.Z)({}, d, a, {
    ref: n
  })));
}); /*#__PURE__*/
const index_module_g = /*#__PURE__*/react.forwardRef((e, n) => {
  const {
      __scopeDropdownMenu: r,
      portalled: t = !0,
      ...p
    } = e,
    d = dist_index_module_w("DropdownMenuContent", r),
    s = react_dropdown_menu_dist_index_module_l(r),
    i = react.useRef(!1);
  return d.isRootMenu ? /*#__PURE__*/react.createElement(index_module_Content, (0,esm_extends/* default */.Z)({
    id: d.contentId,
    "aria-labelledby": d.triggerId
  }, s, p, {
    ref: n,
    portalled: t,
    onCloseAutoFocus: (0,primitive_dist_index_module/* composeEventHandlers */.M)(e.onCloseAutoFocus, e => {
      var o;
      i.current || null === (o = d.triggerRef.current) || void 0 === o || o.focus(), i.current = !1, e.preventDefault();
    }),
    onInteractOutside: (0,primitive_dist_index_module/* composeEventHandlers */.M)(e.onInteractOutside, e => {
      const o = e.detail.originalEvent,
        n = 0 === o.button && !0 === o.ctrlKey,
        r = 2 === o.button || n;
      d.modal && !r || (i.current = !0);
    })
  })) : null;
});
const DropdownMenuGroup = /*#__PURE__*/(/* unused pure expression or super */ null && (c.forwardRef((e, n) => {
  const {
      __scopeDropdownMenu: r,
      ...t
    } = e,
    p = react_dropdown_menu_dist_index_module_l(r); /*#__PURE__*/
  return c.createElement(o.Group, u({}, p, t, {
    ref: n
  }));
}))); /*#__PURE__*/
const DropdownMenuLabel = /*#__PURE__*/(/* unused pure expression or super */ null && (c.forwardRef((e, n) => {
  const {
      __scopeDropdownMenu: r,
      ...t
    } = e,
    p = react_dropdown_menu_dist_index_module_l(r); /*#__PURE__*/
  return c.createElement(o.Label, u({}, p, t, {
    ref: n
  }));
}))); /*#__PURE__*/
const DropdownMenuItem = /*#__PURE__*/react.forwardRef((e, n) => {
  const {
      __scopeDropdownMenu: r,
      ...t
    } = e,
    p = react_dropdown_menu_dist_index_module_l(r); /*#__PURE__*/
  return react.createElement(index_module_Item, (0,esm_extends/* default */.Z)({}, p, t, {
    ref: n
  }));
}); /*#__PURE__*/
const DropdownMenuTriggerItem = /*#__PURE__*/(/* unused pure expression or super */ null && (c.forwardRef((e, n) => {
  const {
      __scopeDropdownMenu: r,
      ...t
    } = e,
    p = react_dropdown_menu_dist_index_module_l(r); /*#__PURE__*/
  return c.createElement(o.SubTrigger, u({}, p, t, {
    ref: n
  }));
}))); /*#__PURE__*/
const DropdownMenuCheckboxItem = /*#__PURE__*/(/* unused pure expression or super */ null && (c.forwardRef((e, n) => {
  const {
      __scopeDropdownMenu: r,
      ...t
    } = e,
    p = react_dropdown_menu_dist_index_module_l(r); /*#__PURE__*/
  return c.createElement(o.CheckboxItem, u({}, p, t, {
    ref: n
  }));
}))); /*#__PURE__*/
const DropdownMenuRadioGroup = /*#__PURE__*/(/* unused pure expression or super */ null && (c.forwardRef((e, n) => {
  const {
      __scopeDropdownMenu: r,
      ...t
    } = e,
    p = react_dropdown_menu_dist_index_module_l(r); /*#__PURE__*/
  return c.createElement(o.RadioGroup, u({}, p, t, {
    ref: n
  }));
}))); /*#__PURE__*/
const DropdownMenuRadioItem = /*#__PURE__*/(/* unused pure expression or super */ null && (c.forwardRef((e, n) => {
  const {
      __scopeDropdownMenu: r,
      ...t
    } = e,
    p = react_dropdown_menu_dist_index_module_l(r); /*#__PURE__*/
  return c.createElement(o.RadioItem, u({}, p, t, {
    ref: n
  }));
}))); /*#__PURE__*/
const DropdownMenuItemIndicator = /*#__PURE__*/(/* unused pure expression or super */ null && (c.forwardRef((e, n) => {
  const {
      __scopeDropdownMenu: r,
      ...t
    } = e,
    p = react_dropdown_menu_dist_index_module_l(r); /*#__PURE__*/
  return c.createElement(o.ItemIndicator, u({}, p, t, {
    ref: n
  }));
}))); /*#__PURE__*/
const DropdownMenuSeparator = /*#__PURE__*/(/* unused pure expression or super */ null && (c.forwardRef((e, n) => {
  const {
      __scopeDropdownMenu: r,
      ...t
    } = e,
    p = react_dropdown_menu_dist_index_module_l(r); /*#__PURE__*/
  return c.createElement(o.Separator, u({}, p, t, {
    ref: n
  }));
}))); /*#__PURE__*/
const DropdownMenuArrow = /*#__PURE__*/react.forwardRef((e, n) => {
  const {
      __scopeDropdownMenu: r,
      ...t
    } = e,
    p = react_dropdown_menu_dist_index_module_l(r); /*#__PURE__*/
  return react.createElement(dist_index_module_Arrow, (0,esm_extends/* default */.Z)({}, p, t, {
    ref: n
  }));
}); /*#__PURE__*/
const react_dropdown_menu_dist_index_module_Root = DropdownMenu;
const Trigger = DropdownMenuTrigger;
const dist_index_module_Content = DropdownMenuContent;
const index_module_Group = (/* unused pure expression or super */ null && (DropdownMenuGroup));
const index_module_Label = (/* unused pure expression or super */ null && (DropdownMenuLabel));
const dist_index_module_Item = DropdownMenuItem;
const TriggerItem = (/* unused pure expression or super */ null && (DropdownMenuTriggerItem));
const index_module_CheckboxItem = (/* unused pure expression or super */ null && (DropdownMenuCheckboxItem));
const index_module_RadioGroup = (/* unused pure expression or super */ null && (DropdownMenuRadioGroup));
const index_module_RadioItem = (/* unused pure expression or super */ null && (DropdownMenuRadioItem));
const index_module_ItemIndicator = (/* unused pure expression or super */ null && (DropdownMenuItemIndicator));
const index_module_Separator = (/* unused pure expression or super */ null && (DropdownMenuSeparator));
const react_dropdown_menu_dist_index_module_Arrow = DropdownMenuArrow;

/***/ }),

/***/ 60158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ useId; }
/* harmony export */ });
/* unused harmony export IdProvider */
/* harmony import */ var _radix_ui_react_use_layout_effect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55483);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);


const r = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))["useId".toString()] || (() => {});
let n = 0;
function useId(o) {
  const [u, i] = react__WEBPACK_IMPORTED_MODULE_0__.useState(r());
  return (0,_radix_ui_react_use_layout_effect__WEBPACK_IMPORTED_MODULE_1__/* .useLayoutEffect */ .b)(() => {
    o || i(t => null != t ? t : String(n++));
  }, [o]), o || (u ? `radix-${u}` : "");
}
function IdProvider({
  children: t
}) {
  return e.useEffect(() => {
    0;
  }, []), /*#__PURE__*/e.createElement(e.Fragment, null, t);
}

/***/ }),

/***/ 17501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Presence; }
/* harmony export */ });
/* harmony import */ var _radix_ui_react_use_layout_effect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55483);
/* harmony import */ var _radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30018);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);



const Presence = u => {
  const {
      present: o,
      children: i
    } = u,
    s = function (n) {
      const [u, o] = react__WEBPACK_IMPORTED_MODULE_0__.useState(),
        i = react__WEBPACK_IMPORTED_MODULE_0__.useRef({}),
        s = react__WEBPACK_IMPORTED_MODULE_0__.useRef(n),
        c = react__WEBPACK_IMPORTED_MODULE_0__.useRef("none"),
        a = n ? "mounted" : "unmounted",
        [d, m] = function (e, n) {
          return react__WEBPACK_IMPORTED_MODULE_0__.useReducer((e, t) => {
            const r = n[e][t];
            return null != r ? r : e;
          }, e);
        }(a, {
          mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
          },
          unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
          },
          unmounted: {
            MOUNT: "mounted"
          }
        });
      return react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        const e = r(i.current);
        c.current = "mounted" === d ? e : "none";
      }, [d]), (0,_radix_ui_react_use_layout_effect__WEBPACK_IMPORTED_MODULE_1__/* .useLayoutEffect */ .b)(() => {
        const e = i.current,
          t = s.current;
        if (t !== n) {
          const u = c.current,
            o = r(e);
          if (n) m("MOUNT");else if ("none" === o || "none" === (null == e ? void 0 : e.display)) m("UNMOUNT");else {
            const e = u !== o;
            m(t && e ? "ANIMATION_OUT" : "UNMOUNT");
          }
          s.current = n;
        }
      }, [n, m]), (0,_radix_ui_react_use_layout_effect__WEBPACK_IMPORTED_MODULE_1__/* .useLayoutEffect */ .b)(() => {
        if (u) {
          const e = e => {
              const n = r(i.current).includes(e.animationName);
              e.target === u && n && m("ANIMATION_END");
            },
            n = e => {
              e.target === u && (c.current = r(i.current));
            };
          return u.addEventListener("animationstart", n), u.addEventListener("animationcancel", e), u.addEventListener("animationend", e), () => {
            u.removeEventListener("animationstart", n), u.removeEventListener("animationcancel", e), u.removeEventListener("animationend", e);
          };
        }
        m("ANIMATION_END");
      }, [u, m]), {
        isPresent: ["mounted", "unmountSuspended"].includes(d),
        ref: react__WEBPACK_IMPORTED_MODULE_0__.useCallback(e => {
          e && (i.current = getComputedStyle(e)), o(e);
        }, [])
      };
    }(o),
    c = "function" == typeof i ? i({
      present: s.isPresent
    }) : react__WEBPACK_IMPORTED_MODULE_0__.Children.only(i),
    a = (0,_radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_2__/* .useComposedRefs */ .e)(s.ref, c.ref);
  return "function" == typeof i || s.isPresent ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(c, {
    ref: a
  }) : null;
};
function r(e) {
  return (null == e ? void 0 : e.animationName) || "none";
}
Presence.displayName = "Presence";

/***/ }),

/***/ 32587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Primitive; }
/* harmony export */ });
/* unused harmony export Root */
/* harmony import */ var _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92434);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65260);



const Primitive = ["a", "button", "div", "h2", "h3", "img", "li", "nav", "ol", "p", "span", "svg", "ul"].reduce((o, i) => ({
  ...o,
  [i]: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((o, m) => {
    const {
        asChild: a,
        ...s
      } = o,
      n = a ? _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_1__/* .Slot */ .g7 : i;
    return react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(n, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, s, {
      ref: m
    }));
  })
}), {});
const Root = (/* unused pure expression or super */ null && (Primitive));

/***/ }),

/***/ 92434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g7": function() { return /* binding */ Slot; }
/* harmony export */ });
/* unused harmony exports Slottable, Root */
/* harmony import */ var _radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30018);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65260);



const Slot = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((e, o) => {
  const {
    children: a,
    ...s
  } = e;
  return react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(a).some(l) ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, react__WEBPACK_IMPORTED_MODULE_0__.Children.map(a, e => l(e) ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(n, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, s, {
    ref: o
  }), e.props.children) : e)) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(n, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, s, {
    ref: o
  }), a);
});
Slot.displayName = "Slot";
const n = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((r, n) => {
  const {
    children: l,
    ...a
  } = r; /*#__PURE__*/
  return react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(l) ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(l, {
    ...o(a, l.props),
    ref: (0,_radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_2__/* .composeRefs */ .F)(n, l.ref)
  }) : react__WEBPACK_IMPORTED_MODULE_0__.Children.count(l) > 1 ? react__WEBPACK_IMPORTED_MODULE_0__.Children.only(null) : null;
});
n.displayName = "SlotClone";
const Slottable = ({
  children: e
}) => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, e);
function l(e) {
  /*#__PURE__*/return react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(e) && e.type === Slottable;
}
function o(e, t) {
  const r = {
    ...t
  };
  for (const n in t) {
    const l = e[n],
      o = t[n];
    /^on[A-Z]/.test(n) ? r[n] = (...e) => {
      null == o || o(...e), null == l || l(...e);
    } : "style" === n ? r[n] = {
      ...l,
      ...o
    } : "className" === n && (r[n] = [l, o].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...r
  };
}
const Root = (/* unused pure expression or super */ null && (Slot));

/***/ }),

/***/ 35849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ useCallbackRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);

function useCallbackRef(r) {
  const t = react__WEBPACK_IMPORTED_MODULE_0__.useRef(r);
  return react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    t.current = r;
  }), react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => (...e) => {
    var r;
    return null === (r = t.current) || void 0 === r ? void 0 : r.call(t, ...e);
  }, []);
}

/***/ }),

/***/ 25320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ useControllableState; }
/* harmony export */ });
/* harmony import */ var _radix_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35849);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);


function useControllableState({
  prop: o,
  defaultProp: r,
  onChange: n = () => {}
}) {
  const [a, u] = function ({
      defaultProp: o,
      onChange: r
    }) {
      const n = react__WEBPACK_IMPORTED_MODULE_0__.useState(o),
        [a] = n,
        u = react__WEBPACK_IMPORTED_MODULE_0__.useRef(a),
        c = (0,_radix_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_1__/* .useCallbackRef */ .W)(r);
      return react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
        u.current !== a && (c(a), u.current = a);
      }, [a, u, c]), n;
    }({
      defaultProp: r,
      onChange: n
    }),
    c = void 0 !== o,
    f = c ? o : a,
    l = (0,_radix_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_1__/* .useCallbackRef */ .W)(n);
  return [f, react__WEBPACK_IMPORTED_MODULE_0__.useCallback(e => {
    if (c) {
      const t = e,
        r = "function" == typeof e ? t(o) : e;
      r !== o && l(r);
    } else u(e);
  }, [c, o, u, l])];
}

/***/ }),

/***/ 55483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useLayoutEffect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82684);

const useLayoutEffect = Boolean(null === globalThis || void 0 === globalThis ? void 0 : globalThis.document) ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : () => {};

/***/ })

}]);